import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import {
    setTheTrackingrecordgetListRetrieveActions, // ticket details
    setthecommentRetieveDatasActions,  // comment records
    setTheTrackingrecordgetList_remarksRetrieveActions, /// remarks records
    settheticketcreateRetieveDatasActions,
    settehTicketStatusChanges,
    SetActiveTabs,
    settheticketTimelineretieveDatasActions,
    setthefeedbackRetieveDatasActions,
    settheRemarkspostActions,
    setthereassignandAssignRejectDataActions,
    settheAssignAndReassigns,
    settheTicketStatusNames,
    settheClientTicketDeatilsDataActions,
    settheExternalTicketviewslisted,
    settheTicketraiseroutes,
    settheTicketTicketJourneyActions,
    settheTicketescalationActions,
    settheTicketViewIds,
    settheroutesforticketAssignsViews
} from "../../../../Redux/Slice"
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { PresentUrl } from "../../../../text/apidata";
import { store } from "../../../../Redux/Store";
import axios from "axios";
import downloadimg from "../../../../Assets/AppComponent/Union (11).svg"
import sendimg from "../../../../Assets/AppComponent/Union (13).svg"
import Uploadimg from "../../../../Assets/AppComponent/Union (12).svg"
import galleyimg from "../../../../Assets/AppComponent/Vector (20).svg"
import Select from "react-select";
import profile2 from "../../../../Assets/AppComponent/Profile/profile2.png";

import PDFIMAGE from "../../../../Assets/AppComponent/Rectangle.png"
import excelimg from "../../../../Assets/AppComponent/download.png"
import gallimages from "../../../../Assets/AppComponent/Vector (20).svg"

import phoneimg from "../../../../Assets/AppComponent/Union (16).svg"

import ArrowImgs from "../../../../Assets/AppComponent/Group 8.svg"
import downloadimg2 from "../../../../Assets/AppComponent/Group 427320153.svg"

import galleryimg2 from "../../../../Assets/AppComponent/image 1.svg"


import pdfimg2 from "../../../../Assets/AppComponent/pdf 1 (1).svg"
import TimelineExample from './HorizontalTimelineticket';


import Bad from "../../../../Assets/AppComponent/Vector (18).svg"
import acceptable from "../../../../Assets/AppComponent/Vector (19).svg"
import good from "../../../../Assets/AppComponent/Union (9).svg"
import excellent from "../../../../Assets/AppComponent/Union (6).svg"


import Badunactive from "../../../../Assets/AppComponent/Union (8).svg"
import acceptableun from "../../../../Assets/AppComponent/Union (7).svg"
import goodun from "../../../../Assets/AppComponent/Vector (16).svg"
import excellentun from "../../../../Assets/AppComponent/Union (10).svg"

import doublArrow from "../../../../Assets/AppComponent/Group 427320086.svg"
import CircularProgressWithLabel from '../CircularProgressWithLabel';
// import { CircularProgress, Box, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from "@mui/material";
import { Card, CardContent, Typography } from "@mui/material";
import ticketactiveimgs from "../../../../Assets/AppComponent/Group.svg"
import { Tooltip } from "react-tooltip";
import dropdowns from "../../../../Assets/AppComponent/Group 427320178.svg"

import tciketimgs from "../../../../Assets/AppComponent/Vector.svg"
import moment from "moment";
import linkthetickets from "../../../../Assets/AppComponent/Union.svg"


import ticketJourneyimg1 from "../../../../Assets/AppComponent/Vector (42).svg"

import ticketJourneyimg2 from "../../../../Assets/AppComponent/Vector (43).svg"
import closeticketviews from "../../../../Assets/AppComponent/Vector (44).svg"





const TicketIViews = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const state = useSelector((state) => state)
    const initialState = {
        name: "",
        documents: [],
        qpms_user_id: state.SideBarFiles.LoginIDs,
        ticket_id: state.StateManagementOverallCall.TicketIDS

    };
    const [remarks, setremarts] = useState(initialState);

    const initialState2 = {
        name: "",
        status: "",
        ticket_id: "",
        qpms_user_id: ""
    };

    const [Commentpopup, setcommetpoup] = useState(false);
    const steps = ["Open", "In Progress", "Review", "Resolved"];
    var currentStep = 1;

    const [comment, setcomment] = useState(initialState2);
    const [TickeREtrievdatas, setTicketRetrievedata] = useState([]);
    const [Remarskspopuo, setremarkspopup] = useState(false)
    // const [remarksseparate, setremarksseparatepopup] = useState(false)

    const [uploadedFiles, setUploadedFiles] = useState([]);

    const [isDragging, setIsDragging] = useState(false);
    const [PresentUrls, setPresentUrls] = useState([]);
    const [presenturlInUrl, seturlandfile] = useState([])


    const [croppedFileState, setcroppedFilestatet] = useState([]);
    const [documentnotuploads, setdosumentuploads] = useState(false)
    const options = [
        { value: "1", label: "Inprocess" },
        { value: "2", label: "Review" },
    ];
    const [isModalOpen, setModalOpen] = useState(false);
    const chatContainerRef = useRef(null);
const [isOpen, setIsOpen] = useState(false);
 const [expanded, setExpanded] = useState(false);
  const limit = 50; // characters before truncation

  const shouldTruncate = TickeREtrievdatas?.remarks && TickeREtrievdatas?.remarks.length > limit;
  const displayText = expanded
    ? TickeREtrievdatas?.remarks
    : shouldTruncate
    ? TickeREtrievdatas?.remarks.slice(0, limit) + "..."
    : TickeREtrievdatas?.remarks

    // Function to auto-scroll to the bottom
    const scrollToBottom = () => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    };

    useEffect(() => {
        dispatch(settheroutesforticketAssignsViews(1))
        dispatch(SetActiveTabs(4));

    }, [])


    // const users = [
    //     { id: 1, name: "John Doe" },
    //     { id: 2, name: "Jane Smith" },
    //     { id: 3, name: "Finance Team" },
    // ];


    const [users, setusers] = useState([])
    const [ActiveofUploads, setActiveonUploads] = useState(1)

    // useEffect(() => {
    //     if (TickeREtrievdatas) {
    //         const l1Users = TickeREtrievdatas.l1_users || [];
    //         const l2Users = TickeREtrievdatas.l2_users || [];
    //         const l3Users = TickeREtrievdatas.l3_users || [];
    //         state.SideBarFiles.LoginIDs
    //         const allUsers = [
    //             ...l1Users.map((user, index) => ({ id: index + 1, name: user.first_name })),
    //             ...l2Users.map((user, index) => ({ id: l1Users.length + index + 1, name: user.first_name })),
    //             ...l3Users.map((user, index) => ({ id: l1Users.length + l2Users.length + index + 1, name: user.first_name }))
    //         ];

    //         setusers(allUsers);
    //     }
    // }, [TickeREtrievdatas]); // Dependency on TickeREtrievdatas to re-run when it's updated
    console.log(ActiveofUploads, "ActiveofUploads");


    // useEffect(() => {
    //     dispatch(settheTicketraiseroutes(8))
    // }, [])



    useEffect(() => {
        if (TickeREtrievdatas) {
            const l1Users = TickeREtrievdatas.l1_users || [];
            const l2Users = TickeREtrievdatas.l2_users || [];
            const l3Users = TickeREtrievdatas.l3_users || [];
            const excludedIDs = state.SideBarFiles.LoginIDs || []; // IDs to exclude

            const allUsers = [
                ...l1Users.map((user, index) => ({
                    id: index + 1,
                    name: user.first_name,
                    login_id: user?.id,
                })),
                ...l2Users.map((user, index) => ({
                    id: l1Users.length + index + 1,
                    name: user.first_name,
                    login_id: user?.id,
                })),
                ...l3Users.map((user, index) => ({
                    id: l1Users.length + l2Users.length + index + 1,
                    name: user.first_name,
                    login_id: user?.id,
                })),
            ];

            // Filter out users whose login_id matches any ID in excludedIDs
            const filteredUsers = allUsers.filter(user => !excludedIDs.includes(user.login_id));

            setusers(filteredUsers);
        }
    }, [TickeREtrievdatas, state.SideBarFiles.LoginIDs]); // Include all relevant dependencies

    const [suggestions, setSuggestions] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);



    const HandleChangescommentsticketactive = (e) => {
        const value = e.target.value;
        setInputValue(value);
        setremarts({
            ...remarks,
            name: value.charAt(0).toUpperCase() + value.slice(1),
        })
        // if (value.includes("@")) {
        //     const searchText = value.split("@").pop().toLowerCase();
        //     if (searchText.trim()) {
        //         const filteredUsers = users.filter((user) =>
        //             user.name.toLowerCase().includes(searchText)
        //         );
        //         setSuggestions(filteredUsers);
        //     } else {
        //         setSuggestions([]);
        //     }
        // } else {
        //     setSuggestions([]);
        // }
        if (value.includes("@")) {
            const searchText = value.split("@").pop().toLowerCase();
            if (searchText.trim()) {
                // Filter users based on the text after "@"
                const filteredUsers = users.filter((user) =>
                    user.name.toLowerCase().includes(searchText)
                );
                setSuggestions(filteredUsers);
            } else {
                // If only "@", show all users
                setSuggestions(users);
            }
        } else {
            setSuggestions([]); // Clear suggestions if no "@" is present
        }

    };

    const handleSelectSuggestion = (user) => {
        // const updatedValue = remarks?.name.replace(/@\w*$/, `@${user?.name} `);
        // setremarts({
        //     ...remarks,
        //     name: updatedValue,
        // })
        if (!user || !user.name) {
            console.error("Invalid user or user name");
            return;
        }

        const updatedValue = remarks?.name.replace(/@\w*$/, `@${user.name} `);
        setremarts({
            ...remarks,
            name: updatedValue,
        });

        setSuggestions([]);
        setActiveSuggestionIndex(-1);
    };


    useEffect(() => {
        // Automatically select the first suggestion when suggestions are updated
        if (suggestions.length > 0 && activeSuggestionIndex === -1) {
            setActiveSuggestionIndex(0); // Select the first suggestion by default
        }
    }, [suggestions]);

    const HandleSubmitticketactive = (e) => {
        e.preventDefault(); // Prevent default form submission behavior

        // Check if no suggestions are selected and the form is being submitted normally
        if (activeSuggestionIndex === -1) {
            HandleRemarksWithudsusers();
        }
        else if (activeSuggestionIndex === 0) {
            HandleRemarksWithudsusers();

        }
    }
    // console.log(suggestions, "piasudpoaisd suggestions", remarks.name, activeSuggestionIndex);

    const handleKeyDown = (e) => {
        if (e.key === "ArrowDown") {
            // Navigate down the suggestions
            setActiveSuggestionIndex((prevIndex) =>
                prevIndex < suggestions.length - 1 ? prevIndex + 1 : prevIndex
            );
        } else if (e.key === "ArrowUp") {
            // Navigate up the suggestions
            setActiveSuggestionIndex((prevIndex) =>
                prevIndex > 0 ? prevIndex - 1 : prevIndex
            );
        } else if (e.key === "Enter" && activeSuggestionIndex >= 0) {
            // handleSelectSuggestion(suggestions[activeSuggestionIndex]);
            // e.preventDefault(); // Prevent form submission if suggestion is selected
            if (activeSuggestionIndex >= 0 && activeSuggestionIndex < suggestions.length) {
                handleSelectSuggestion(suggestions[activeSuggestionIndex]);
            }
            e.preventDefault(); // Prevent form submission if suggestion is selected

        }
    };


    // const highlightMatch = (suggestion, searchText) => {
    //     if (!searchText) return suggestion;

    //     // Find the index of the match and highlight it
    //     const matchIndex = suggestion.toLowerCase().indexOf(searchText.toLowerCase());

    //     if (matchIndex === -1) return suggestion; // No match found

    //     return (
    //         <>
    //             {suggestion.slice(0, matchIndex)}
    //             <span style={{ fontWeight: "bold", color: "#007bff" }}>
    //                 {suggestion.slice(matchIndex, matchIndex + searchText.length)}
    //             </span>
    //             {suggestion.slice(matchIndex + searchText.length)}
    //         </>
    //     );
    // };


    const highlightMatch = (suggestion, searchText) => {
        if (!searchText) return suggestion;

        // Find the index of the match and highlight it
        const matchIndex = suggestion.toLowerCase().indexOf(searchText.toLowerCase());

        if (matchIndex === -1) return suggestion; // No match found

        return (
            <>
                {suggestion.slice(0, matchIndex)}
                <span style={{ fontWeight: "bold", color: "#234492" }}>
                    {suggestion.slice(matchIndex, matchIndex + searchText.length)}
                </span>
                {suggestion.slice(matchIndex + searchText.length)}
            </>
        );
    };


    // Scroll to bottom when messages change
    useEffect(() => {
        scrollToBottom();
    }, [state.retrievetheRemarks.Remarksdataslist]);


    const timelineRef = useRef(null);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (timelineRef.current) {
                timelineRef.current.scrollTop = timelineRef.current.scrollHeight;
                // console.log(timelineRef.current.scrollHeight, "asoduaosdiapsodupoasd ");

            }
        }, 100); // Adjust the delay as needed
        return () => clearTimeout(timeout); // Clean up timeout
    }, [
        state.commentsDatas.CommentsDatas,
        state.ticketFeedbacklistedslice.feedbackrecords,
        state.retrievetheRemarks.Remarksdataslist,
        state.FormsIDList.ActiveTabs
    ]);


    const timelineRefremarks = useRef(null);




    useEffect(() => {
        const timeout = setTimeout(() => {
            if (timelineRefremarks.current) {
                timelineRefremarks.current.scrollTop = timelineRefremarks.current.scrollHeight;
                // console.log(timelineRef.current.scrollHeight, "asoduaosdiapsodupoasd ");

            }
        }, 100); // Adjust the delay as needed
        return () => clearTimeout(timeout); // Clean up timeout
    }, [
        state.commentsDatas.CommentsDatas,
        state.ticketFeedbacklistedslice.feedbackrecords,
        state.retrievetheRemarks.Remarksdataslist,
        state.FormsIDList.ActiveTabs
    ]);


    const Remarkesref = useRef(null);

    const scrollToBottomrealremarks = () => {
        if (Remarkesref.current) {
            Remarkesref.current.scrollTop = Remarkesref.current.scrollHeight;
        }
    };

    // Scroll to bottom when messages change
    useEffect(() => {
        scrollToBottomrealremarks();
    }, [state.commentsDatas.CommentsDatas, state.FormsIDList.ActiveTabs]);

    const [progress, setProgress] = React.useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
        }, 800);

        return () => {
            clearInterval(timer);
        };
    }, []);




    const [TicketConfirmPopup, setTicketConfirmPopup] = useState(false)
    const [TicketTimeline, setTicketLIne] = useState([])
    const [Escalationpopup, setEscalationpoup] = useState(true);
    const [showTooltip, setShowTooltip] = useState(false);

    const [showTooltipone, setShowTooltipone] = useState(false);
    const [showTooltiptwo, setShowTooltiptwo] = useState(false);

    const [showToolphone, setShowToolPhone] = useState(false);

    const scrollRef = useRef(null);
    const [StoretheEscalate, setStoreexcalated] = useState("")


    const [remainingTime, setremainingTime] = useState(1);
    const [activeFeedback, setactiveFeedback] = useState("Bad")
    const [ticketactivenames, setticketactivenames] = useState("")

    const feedbackOptions = [
        { id: "bad", label: "Bad", imgSrc: activeFeedback == "bad" ? Bad : Badunactive, backimg: Bad },
        { id: "acceptable", label: "Acceptable", imgSrc: activeFeedback == "acceptable" ? acceptable : acceptableun, backimg: acceptable },
        { id: "good", label: "Good", imgSrc: activeFeedback == "good" ? good : goodun, backimg: good },
        { id: "excellent", label: "Excellent", imgSrc: activeFeedback == "excellent" ? excellent : excellentun, backimg: excellent },
    ];


    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);

        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = dateObject.getFullYear();

        return `${day} / ${month} / ${year}`;
    };



    useEffect(() => {
        // Set initial scroll position
        if (scrollRef.current) {
            scrollRef.current.scrollTop = 100; // Vertical scroll
            scrollRef.current.scrollLeft = 50; // Horizontal scroll
        }
    }, []);

    const formatDateTime = (dateString) => {
        const dateObject = new Date(dateString);

        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = dateObject.getFullYear();

        const hours = dateObject.getHours();
        const minutes = String(dateObject.getMinutes()).padStart(2, '0');

        // Convert hours to 12-hour format and determine AM/PM
        const amPm = hours >= 12 ? 'pm' : 'am';
        const formattedHours = hours % 12 || 12; // Converts 0 to 12 for midnight

        return `${day}/${month}/${year}, ${formattedHours}.${minutes} ${amPm}`;
    };
    useEffect(() => {
        if (state.ticketTimeLIneSlicedata.TicketTimeLinerecords) {
            setTicketLIne([state.ticketTimeLIneSlicedata.TicketTimeLinerecords])
        }
    }, [state.ticketTimeLIneSlicedata.TicketTimeLinerecords])

    // useEffect(()=>{
    //     if(ticketretrieve)
    // })

    const StepTickets = Object.entries(state.ticketTimeLIneSlicedata.TicketTimeLinerecords);

    var DurationOpions = [
        {
            value: "0",
            label: "Minutes"
        },
        {
            value: "1",
            label: "Hours"
        },
        {
            value: "2",
            label: "Day"
        },
    ]
    // function extractTimeFromDate(dateString, options = { hour: "2-digit", minute: "2-digit", second: "2-digit" }) {
    //     return new Date(dateString).toLocaleTimeString("en-US", options);
    // }
    function extractTimeFromDate(dateString, options = { hour: "2-digit", minute: "2-digit", hour12: true }) {
        return new Date(dateString).toLocaleTimeString("en-US", options);
    }



    // const formatedDateList = (dateString) => {
    //     const date = new Date(dateString);

    //     // Options for date formatting
    //     const options = {
    //         month: "short", // e.g., Dec
    //         day: "2-digit", // e.g., 22
    //         year: "numeric", // e.g., 2024
    //         hour: "2-digit", // e.g., 10
    //         minute: "2-digit", // e.g., 00
    //         // hour12: true, // e.g., 10:00 AM/PM
    //     };

    //     return date.toLocaleDateString("en-US", options) + ` (${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })})`;
    // };

    const downloadAll = (remarkdocuments) => {
        const allLinks = remarkdocuments;

        if (!allLinks || allLinks.length === 0) {
            alert("No documents available for download.");
            return;
        }

        allLinks.forEach((link, index) => {
            setTimeout(() => {
                window.open(link, "_blank");
            }, index * 500); // Opens a new window every 500ms (adjust as needed)
        });
    };



    const formatedDateList = (dateString) => {
        const date = new Date(dateString);

        // Options for date formatting (only date)
        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        // Options for time formatting (only time)
        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}, ${formattedTime}`;
    };

    const formatedDateListwithouttime = (dateString) => {
        const date = new Date(dateString);

        // Options for date formatting (only date)
        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        // Options for time formatting (only time)
        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}`;
    };


    // function parseTimeToMs(timeString) {
    //     const [hours, minutes, seconds] = timeString.split(':').map(Number);
    //     return (hours * 3600 + minutes * 60 + (seconds || 0)) * 1000;
    // }

    // function formatMsToTime(ms) {
    //     const totalSeconds = Math.floor(ms / 1000);
    //     const hours = Math.floor(totalSeconds / 3600);
    //     const minutes = Math.floor((totalSeconds % 3600) / 60);
    //     const seconds = totalSeconds % 60;
    //     return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    // }


    function convertToMinutes(days, hours, minutes) {
        return (days * 24 * 60) + (hours * 60) + minutes;
    }

    function convertToTimeFormat(totalMinutes) {
        const days = Math.floor(totalMinutes / (24 * 60));
        totalMinutes -= days * (24 * 60);

        const hours = Math.floor(totalMinutes / 60);
        totalMinutes -= hours * 60;

        const minutes = totalMinutes;
        console.log(days, hours, minutes, "days, hours, minutes");


        return { days, hours, minutes };
    }



    function calculateTimeDifference(timeDifferenceFormatted, timeDifferenceLevel) {
        const timeFormattedMs = timeDifferenceFormatted;
        const timeLevelMs = timeDifferenceLevel;
        //  console.log(timeFormattedMs ,"timeFormattedMs timeLevelMs" , timeLevelMs);


        let durationMs = timeFormattedMs - timeLevelMs;
        console.log(durationMs, "ssad durationMs");

        if (durationMs <= 0) {
            return "Overdue";
        }

        const days = Math.floor(durationMs / (24 * 60 * 60 * 1000));
        durationMs %= (24 * 60 * 60 * 1000);

        const hours = Math.floor(durationMs / (60 * 60 * 1000));
        durationMs %= (60 * 60 * 1000);

        const minutes = Math.floor(durationMs / (60 * 1000));

        return `${days} days ${hours} hrs ${minutes} minutes`;
    }


    // const overdueFunctions = () => {
    //     const createdAt = TickeREtrievdatas?.created_at;
    //     const TAT = TickeREtrievdatas?.client_id?.l1_user_TAT;
    //     const LevelonbeTAT = TickeREtrievdatas?.client_id?.l1_user_TAT
    //     const Levelonbetypes = TickeREtrievdatas?.client_id?.l1_time_type
    //     function formatTime(ms) {
    //         const days = Math.floor(ms / (1000 * 60 * 60 * 24));
    //         const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    //         const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));

    //         return `${days},${hours},${minutes}`;
    //     }


    //     function formatTimelevel(ms) {
    //         const days = Levelonbetypes == 2 ? ms : 0;
    //         const hours = Levelonbetypes == 1 ? ms : 0;
    //         const minutes = Levelonbetypes == 0 ? ms : 0;
    //         return `${days},${hours},${minutes} `;
    //     }


    //     if (createdAt && TAT) {
    //         const createdDate = new Date(createdAt);


    //         const specificDate = new Date(createdAt);

    //         const currentDate = new Date();
    //         const differenceInMilliseconds = specificDate - currentDate;


    //         const diffInSeconds = Math.abs(differenceInMilliseconds) / 1000; // absolute value in seconds
    //         const diffInMinutes = Math.floor(diffInSeconds / 60);            // in minutes
    //         const diffInHours = Math.floor(diffInMinutes / 60);              // in hours
    //         const diffInDays = Math.floor(diffInHours / 24);                 // in days

    //         // Calculate the remaining hours and minutes
    //         const remainingHours = diffInHours % 24;                         // remaining hours after extracting days
    //         const remainingMinutes = diffInMinutes % 60;                     // remaining minutes after extracting hours

    //         // / Format the output
    //         console.log(`Difference: asdasdasdds  ${diffInDays} days, ${remainingHours} hours, ${remainingMinutes} minutes`);




    //         const timeDifferenceInMs = currentDate - createdDate;
    //         console.log(currentDate, "currentDate asdasdasd", createdDate);




    //         const timeDifferenceFormatted = formatTime(timeDifferenceInMs);



    //         var timeDifferenceLevel = formatTimelevel(LevelonbeTAT);

    //         console.log(timeDifferenceFormatted, "timeDifferenceFormatted", timeDifferenceLevel);


    //         const period1Minutes = convertToMinutes(diffInDays, remainingHours, remainingMinutes)
    //         const period2Minutes = convertToMinutes(
    //             Levelonbetypes === "2" ? Number(LevelonbeTAT) : 0,
    //             Levelonbetypes === "1" ? Number(LevelonbeTAT) : 0,
    //             Levelonbetypes === "0" ? Number(LevelonbeTAT) : 0
    //         );

    //         // /            console.log(period1Minutes, period2Minutes, "period1Minutes period1Minutes", Levelonbetypes, LevelonbeTAT,);


    //         const differenceInMinutes = period1Minutes - period2Minutes;


    //         const result = convertToTimeFormat(differenceInMinutes);




    //         setremainingTime(differenceInMinutes);



    //     }
    //     return "";
    // }
    const formatedDateListwithtime = (dateString) => {
        const date = new Date(dateString);

        // Options for date formatting (only date)
        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        // Options for time formatting (only time)
        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}-${formattedTime}`;
    };


    const overdueFunctions = (ticketretrieve) => {
        const convertToMinutes = (days, hours, minutes) => (days * 24 * 60) + (hours * 60) + minutes;
        let differenceInMinutes
        // const convertToTimeFormat = (totalMinutes) => {
        //     const days = Math.floor(totalMinutes / (24 * 60));
        //     totalMinutes -= days * (24 * 60);
        //     const hours = Math.floor(totalMinutes / 60);
        //     const minutes = totalMinutes - (hours * 60);
        //     return { days, hours, minutes };
        // };

        function calculateTimeStatus(differenceInMinutes) {

            console.log(differenceInMinutes, "differenceInMinutes", differenceInMinutes * -1);

            if (differenceInMinutes > 0 || differenceInMinutes == 0) {
                return "Overdue";
            }

            if ((differenceInMinutes * -1) >= 1440) {
                // More than or equal to 1 day
                const days = Math.floor(differenceInMinutes * -1) / (60 * 24);
                return `${days} Days left`;
            }

            if ((differenceInMinutes * -1) >= 60) {
                // More than or equal to 1 hour
                const hours = Math.floor(differenceInMinutes * -1 / 60);
                return `${hours} Hours left`;
            }

            // Less than 1 hour
            const minutes = differenceInMinutes * -1;
            return `Minutes left 
            ${minutes}`;
        }
        var remainingTimevalues


        const formatTime = (ms) => {
            const days = Math.floor(ms / (1000 * 60 * 60 * 24));
            const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
            return { days, hours, minutes };
        };

        const formatTimeLevel = (ms, Levelonbetypes) => {
            return {
                days: Levelonbetypes === "2" ? ms : 0,
                hours: Levelonbetypes === "1" ? ms : 0,
                minutes: Levelonbetypes === "0" ? ms : 0,
            };
        };

        if (ticketretrieve?.created_at && ticketretrieve?.client_id?.l1_user_TAT) {
            const createdDate = new Date(ticketretrieve.created_at);
            const currentDate = new Date();
            const differenceInMs = currentDate - createdDate;

            const timeDifference = formatTime(differenceInMs);

            const LevelonbeTAT = Number(ticketretrieve.client_id.l1_user_TAT);
            const Levelonbetypes = ticketretrieve.client_id.l1_time_type;

            const period1Minutes = convertToMinutes(
                timeDifference.days,
                timeDifference.hours,
                timeDifference.minutes
            );

            const period2Minutes = convertToMinutes(
                Levelonbetypes === "2" ? LevelonbeTAT : 0,
                Levelonbetypes === "1" ? LevelonbeTAT : 0,
                Levelonbetypes === "0" ? LevelonbeTAT : 0
            );

            differenceInMinutes = period1Minutes - period2Minutes;
            remainingTimevalues = calculateTimeStatus(differenceInMinutes);
            // console.log(differenceInMinutes, " asdasdasd differenceInMnutes", differenceInMinutes > 0, remainingTimevalues);
            // Convert the difference back to days, hours, and minutes
            // Debugging log






            return remainingTimevalues

            // return `${differenceInMinutes > 0 || isNaN(differenceInMinutes) ?

            //     "Overdue" :
            //     `Minutes left ${differenceInMinutes * -1}`}`;
        }

        return remainingTimevalues


    };

    const formatDatefeed = (dateString) => {
        const dateObject = new Date(dateString);

        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = dateObject.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const HandleChanges = (e) => {
        setremarts((pre) => {
            return {
                ...pre,
                [e.target.name]: e.target.value,
            };
        });
    };



    const HandleChangescomments = (e) => {
        const inputValue = e.target.value;
        setcomment((pre) => {
            return {
                ...pre,
                [e.target.name]: inputValue.charAt(0).toUpperCase() + inputValue.slice(1),
            };



        });


    };



    useEffect(() => {
        // console.log(TickeREtrievdatas ,"asodoasidosd",
        //     TickeREtrievdatas?.client_ticket_id != null ? TickeREtrievdatas?.client_ticket_id : TickeREtrievdatas?.id,
        // );
        if (TickeREtrievdatas?.id != null && TickeREtrievdatas?.id != undefined) {
            const payload = {
                EditId: TickeREtrievdatas?.id,
                paramsdata: {
                    from_place: "external_ticket"
                }
            }
            dispatch(settheTicketescalationActions(payload))
        }

        // else if (TickeREtrievdatas?.client_ticket_id == null && TickeREtrievdatas != undefined &&
        //     TickeREtrievdatas.id != undefined &&
        //     TickeREtrievdatas?.id != null && TickeREtrievdatas?.id != undefined) {
        //     const payload = {
        //         // EditIdEditId: TickeREtrievdatas?.client_ticket_id != null ? TickeREtrievdatas?.client_ticket_id : TickeREtrievdatas?.id,
        //         EditId: TickeREtrievdatas.id,
        //         paramsdata: {
        //             // from_place: "external_ticket"
        //             form_place: "internal_ticket"
        //         }
        //     }
        //     dispatch(settheTicketescalationActions(payload))
        // }
        // }

    }, [TickeREtrievdatas])


    //// TICKET RETRIEV
    useEffect(() => {
        if (state.StateManagementOverallCall.TicketIDS) {
            const payload = {
                id: state.StateManagementOverallCall.TicketIDS

            }
            dispatch(setTheTrackingrecordgetListRetrieveActions(payload))
        }
    }, [state.StateManagementOverallCall.TicketIDS])
    console.log(state.StateManagementOverallCall.TicketIDS, "TicketIDS");

    /// REMARKS RETRIEVE

    useEffect(() => {
        if (state.StateManagementOverallCall.TicketIDS && state.FormsIDList.ActiveTabs == 1) {
            const payload = {
                ticket: state.StateManagementOverallCall.TicketIDS

            }
            dispatch(setTheTrackingrecordgetList_remarksRetrieveActions(payload))
        }
    }, [state.StateManagementOverallCall.TicketIDS, state.FormsIDList.ActiveTabs])

    useEffect(() => {
        if (state.StateManagementOverallCall.TicketIDS) {

            const payload = {
                EditId: state.StateManagementOverallCall.TicketIDS

            }

            dispatch(settheClientTicketDeatilsDataActions(payload))
        }
    }, [state.StateManagementOverallCall.TicketIDS])

    console.log(state.TicketDetailsListedNames.ClientTicketDetailsForInternal.internal_ticket_serializer, " internal_ticket_serializer ,ClientTicketDetailsForInternal  leiuilqw ie");


    useEffect(() => {
        if (state.StateManagementOverallCall.TicketIDS) {
            const payload = {
                ticket_id: state.StateManagementOverallCall.TicketIDS

            }
            dispatch(settheticketTimelineretieveDatasActions(payload))
        }
    }, [state.StateManagementOverallCall.TicketIDS, state.ticketstatuschanges.ticketStatusChanges])

    // console.log(state.retrievetheRemarks.Remarksdataslist, "TicketTimeLinerecords");


    useEffect(() => {
        if (state.StateManagementOverallCall.TicketIDS !== ""

            // && state.FormsIDList.ActiveTabs === 3
        ) {
            const payload = {
                ticket: state.StateManagementOverallCall.TicketIDS

            }
            dispatch(setthecommentRetieveDatasActions(payload))
        }
    }, [state.StateManagementOverallCall.TicketIDS,state.internalcommandticketpost.internaldepartmentticketpost])


    useEffect(() => {
        if (state.StateManagementOverallCall.TicketIDS) {
            const payload = {
                ticket: state.StateManagementOverallCall.TicketIDS

            }
            dispatch(setthefeedbackRetieveDatasActions(payload))
        }
    }, [state.StateManagementOverallCall.TicketIDS, state.FormsIDList.ActiveTabs == 2])





    useEffect(() => {
        if (TickeREtrievdatas?.id !== ""
            && TickeREtrievdatas?.id !== "" && TickeREtrievdatas?.id != undefined
        ) {
            const payload = {
                client_ticket: TickeREtrievdatas?.id,
                // ticket_id: state.StateManagementOverallCall.TicketIDS

            }
            dispatch(settheTicketTicketJourneyActions(payload))
        }
    }, [TickeREtrievdatas, state.FormsIDList.ActiveTabs == 4])





    useEffect(() => {
        if (state.RetrieveTickingSystemdatas.clientTicketingrecordRetrieve) {
            setremarts({
                ...remarks,
                qpms_user_id: state.RetrieveTickingSystemdatas?.clientTicketingrecordRetrieve?.ticket_data?.qpms_user_id?.id
            })

            setcomment({
                ...comment,
                qpms_user_id: state.RetrieveTickingSystemdatas?.clientTicketingrecordRetrieve?.ticket_data?.qpms_user_id?.id
            })

            setTicketRetrievedata(state.RetrieveTickingSystemdatas?.clientTicketingrecordRetrieve?.ticket_data)

        }
    }, [state.RetrieveTickingSystemdatas.clientTicketingrecordRetrieve])

    const capitalizeFirstLetter = (Letter) => {
        return Letter.charAt(0).toUpperCase() + Letter.slice(1);
    };


    const HandleFeedbackpopup = () => {
        setcommetpoup(true);

    }


    const handleDrop = useCallback((event) => {
        event.preventDefault();

        const droppedFiles = Array.from(event.dataTransfer.files);

        // Filter files based on type and size
        // const validFiles = droppedFiles.filter((file) => {
        //     const isPhotoOrVideo = file.type.startsWith("image/") || file.type.startsWith("video/");
        //     const isUnderSizeLimit = file.size <= 5 * 1024 * 1024; // 5 MB in bytes

        //     if (!isPhotoOrVideo) {
        //         toast.error(`Invalid file type: ${file.name}`);
        //     }
        //     if (!isUnderSizeLimit && isPhotoOrVideo) {
        //         toast.error(`File too large: ${file.name} exceeds 5 MB`);
        //     }

        //     return isPhotoOrVideo && isUnderSizeLimit;
        // });


        const validFiles = droppedFiles.filter((file) => {
            const isPhotoOrVideo = file.type.startsWith("image/") || file.type.startsWith("video/");
            const isExcel = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type === "application/vnd.ms-excel";
            const isPdf = file.type === "application/pdf";
            const isEmail = file.type === "message/rfc822"; // MIME type for email files
            const isUnder5MB = file.size <= 25 * 1024 * 1024; // 5 MB size limit

            if (!isUnder5MB) {
                toast.error(`${file.name} exceeds the 25 MB size limit.`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }


            // return isUnder5MB;


            return isUnder5MB;

            // return isPhotoOrVideo || isExcel || isPdf || isEmail;
        });

        if (validFiles.length === 0) {
            return; // Exit if no valid files
        }

        validFiles.forEach((file) => {
            const reader = new FileReader();

            reader.onload = () => {
                const base64Url = reader.result;


                // setUploadedFiles((prevFiles) => [
                //     ...prevFiles,
                //     // { file, base64Url },
                //     {  base64Url },

                // ]);
                setUploadedFiles((prevFiles) => [...prevFiles, base64Url]);


            };

            reader.readAsDataURL(file);
        });

        if (validFiles.length > 0) {
            const newFiles = validFiles.map((file) => URL.createObjectURL(file));

        
            setUploadedFiles((prev) => [...prev, ...newFiles]);
            setdosumentuploads(true);
            setcroppedFilestatet((prev) => [...prev, ...validFiles]);
    
    
            const generateRandomNumber = () => {
                return Math.floor(Math.random() * 100000);
            };

            const createPresentData = (file) => {
                const randomNumber = generateRandomNumber();
                const formattedFilename = `ticketing_system/ticket/${file.name}`; // Adjust the filename as needed
                return {
                    multiple_files: [
                        {
                            filename: formattedFilename,
                            file_type: file.type,
                        },
                    ],
                };
            };

            validFiles.forEach((filelist) => {
                let presentData = createPresentData(filelist);
                axios({
                    url: PresentUrl,
                    method: 'post',
                    data: presentData,
                    headers: {
                        Authorization:
                            "Bearer " + store.getState().users.UserData.session.token,
                    },
                })
                    .then((response) => {
                        console.log('Files uploaded successfully:', response.data);
                        const uploadedFiles = response.data.data; // Adjust based on actual response structure

                        const newUrls = uploadedFiles.map(file => ({
                            url: file, // Adjust this based on the actual response
                            type: filelist.type,
                            putfiles: filelist

                        }));


                        setPresentUrls(prevUrls => [...prevUrls, ...newUrls]);

                        const SendUrl = String(response.data.data).split("?")[0]; // Extract URL up to '?'
                        console.log(SendUrl, "SendUrl");

                        if (SendUrl) {
                            seturlandfile(prevUrls => [...prevUrls, SendUrl]); // Add the URL to the array
                        }

                    })
                    .catch((error) => {
                        console.error('Error uploading files:', error);
                    });
            });
        }
    }, []);


    const handleDragOver = (event) => {

        event.preventDefault();
        event.stopPropagation();

    };
    const handleDragEnter = () => setIsDragging(true);
    const handleDragLeave = () => setIsDragging(false);


    const events = [
        { date: "2021-01-01", title: "Open" },
        { date: "2021-06-01", title: "In Progress" },
        { date: "2022-01-01", title: "Review" },
        { date: "2022-01-01", title: "Resolved" },

    ];


    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        // Filter files based on type and size
        // const validFiles = files.filter((file) => {
        //     const isPhotoOrVideo = file.type.startsWith("image/") || file.type.startsWith("video/");
        //     const isUnderSizeLimit = file.size <= 5 * 1024 * 1024; // 5 MB in bytes

        //     if (!isPhotoOrVideo) {
        //         toast.error(`Invalid file type: ${file.name}`);
        //     }
        //     if (!isUnderSizeLimit && isPhotoOrVideo) {
        //         toast.error(`File too large: ${file.name} exceeds 5 MB`);
        //     }

        //     return isPhotoOrVideo && isUnderSizeLimit;
        // });

        const validFiles = files.filter((file) => {
            const isPhotoOrVideo = file.type.startsWith("image/") || file.type.startsWith("video/");
            const isExcel = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type === "application/vnd.ms-excel";
            const isPdf = file.type === "application/pdf";
            const isEmail = file.type === "message/rfc822"; // MIME type for email files
            const isUnder5MB = file.size <= 25 * 1024 * 1024; // 5 MB size limit
            // return isPhotoOrVideo || isExcel || isPdf || isEmail;
            if (!isUnder5MB) {
                toast.error(`${file.name} exceeds the 25 MB size limit.`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }


            return isUnder5MB;

        });


        if (validFiles.length === 0) {
            return; // Exit if no valid files
        }

        const newFiles = validFiles.map((file) => URL.createObjectURL(file));
        setUploadedFiles((prev) => [...prev, ...newFiles]);
        setdosumentuploads(true);
        setcroppedFilestatet((prev) => [...prev, ...validFiles]);

        const generateRandomNumber = () => {
            return Math.floor(Math.random() * 100000);
        };

        const createPresentData = (file) => {
            const randomNumber = generateRandomNumber();
            const formattedFilename = `ticketing_system/ticket/${file.name}`; // Adjust the filename as needed
            return {
                multiple_files: [
                    {
                        filename: formattedFilename,
                        file_type: file.type,
                    },
                ],
            };
        };



        validFiles.forEach((filelist) => {
            let presentData = createPresentData(filelist);
            axios({
                url: PresentUrl,
                method: 'post',
                data: presentData,
                headers: {
                    Authorization:
                        "Bearer " + store.getState().users.UserData.session.token,
                },
            })
                .then((response) => {
                    console.log('Files uploaded successfully:', response.data);
                    const uploadedFiles = response.data.data; // Adjust based on actual response structure

                    const newUrls = uploadedFiles.map(file => ({
                        url: file, // Adjust this based on the actual response
                        type: filelist.type,
                        putfiles: filelist

                    }));


                    setPresentUrls(prevUrls => [...prevUrls, ...newUrls]);

                    const SendUrl = String(response.data.data).split("?")[0]; // Extract URL up to '?'
                    // console.log(SendUrl, "SendUrl");

                    if (SendUrl) {
                        seturlandfile(prevUrls => [...prevUrls, SendUrl]); // Add the URL to the array
                    }

                })
                .catch((error) => {
                    console.error('Error uploading files:', error);
                });

        });



    };




    useEffect(() => {
        if (uploadedFiles.length == 0) {
            setdosumentuploads(false)
        }
    }, [uploadedFiles])

    const removeFile = (index) => {
        setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
        setcroppedFilestatet((prev) => prev.filter((_, i) => i !== index));
        setPresentUrls((prev) => prev.filter((_, i) => i !== index));
        seturlandfile((prev) => prev.filter((_, i) => i !== index));
    };


    useEffect(() => {
        if (presenturlInUrl) {
            setremarts(prevState => ({
                ...prevState,
                documents: presenturlInUrl // Assign the new documents list
            }));
        }

    }, [presenturlInUrl])

    const HandleRemarsks = (e, ticketvalues, contextofticket) => {


        // console.log(e, "uepqwueqwieoiqwe pqowiepoqwe", ticketvalues, contextofticket);


        const fetchUploadFiles = async () => {

            await Promise.all(PresentUrls.map(async (item, index) => {
                try {
                    if (item != undefined && item != null) {

                        const response = await fetch(item.url, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': item.type,
                                "x-amz-acl": "public-read"
                            },
                            body: item.putfiles,
                        });
                        if (PresentUrls.length == index + 1) {
                            const payload = {
                                data: {
                                    name: comment.name,
                                    documents: remarks.documents,
                                    // qpms_user_id: "",
                                    ticket_id: state.StateManagementOverallCall.TicketIDS,
                                    // status: "1"

                                },
                                remarks: e == 3 ? 3 : 2,
                                ticketcall: ticketvalues
                            }
                            dispatch(settheticketcreateRetieveDatasActions(payload))
                            setremarts(initialState)
                            setcomment(initialState2)

                            setPresentUrls([])
                            // if (e != 3) {

                            //     const ticketpay = {
                            //         EditID: state.StateManagementOverallCall.TicketIDS,
                            //         Rawdata: {
                            //             status: comment.status
                            //         }



                            //     }
                            //     dispatch(settehTicketStatusChanges(ticketpay))
                            // }

                            setdosumentuploads(false);
                            seturlandfile([]);
                            setUploadedFiles([]);
                            setremarkspopup(false)
                            setcomment(initialState2)

                        }
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }

                        const data = await response.json();
                        console.log('Files uploaded successfully:', data);
                    }
                } catch (error) {
                    console.error('Error uploading files:', error);
                }
            }));
        };

        // if (comment.name !== "" && comment.status !== "") {
    if (comment?.name != null && comment?.name != undefined &&
      comment?.name.trim() != "" || documentnotuploads == true) {

            if (documentnotuploads) {

                fetchUploadFiles()
            }

            else {
                const payload = {
                    data: {
                        name: comment.name,
                        documents: remarks.documents,
                        // qpms_user_id: "",
                        ticket_id: state.StateManagementOverallCall.TicketIDS,
                        // status: "1"


                    },
                    remarks: e == 3 ? 3 : 2,
                    ticketcall: ticketvalues
                }
                dispatch(settheticketcreateRetieveDatasActions(payload))

                // if (ticketvalues) {
                //     const payload = {
                //         data: {
                //             name: "In Progress to Review",
                //             description: "In Progress to Review",
                //             documents: [],
                //             // qpms_user_id: "",
                //             ticket_id: state.StateManagementOverallCall.TicketIDS,
                //             // status: "1",
                //             qpms_user_id: state.SideBarFiles.LoginIDs,



                //         },
                //         remarks: 1
                //     }
                //     dispatch(settheRemarkspostActions(payload))

                // }
                setdosumentuploads(false);
                seturlandfile([]);
                setUploadedFiles([]);
                setremarkspopup(false)
                // if (e != 3) {
                //     const ticketpay = {
                //         EditID: state.StateManagementOverallCall.TicketIDS,
                //         Rawdata: {
                //             status: comment.status
                //         }


                //     }
                //     dispatch(settehTicketStatusChanges(ticketpay))
                // }

                setremarts(initialState)
                setcomment(initialState2)
                setPresentUrls([])



            }




        }
        else {
            toast.error("Please enter the valid details");
        }

    }

    const HandleRemarksWithudsForreview = (e) => {
        const payload = {
            data: {
                name: ticketactivenames,
                documents: [],
                ticket_id: state.StateManagementOverallCall.TicketIDS,
                qpms_user_id: state.SideBarFiles.LoginIDs,
            },
            remarks: 1
        }
        dispatch(settheticketcreateRetieveDatasActions(payload))

    }
    const HandleRemarksWithudsusers = (e) => {
        console.log(remarks.name, "AJHSOKAJSkJASLKJSAS remarks.name");

        const fetchUploadFiles = async () => {

            await Promise.all(PresentUrls.map(async (item, index) => {
                try {
                    if (item != undefined && item != null) {

                        const response = await fetch(item.url, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': item.type,
                                "x-amz-acl": "public-read"
                            },
                            body: item.putfiles,
                        });
                        if (PresentUrls.length == index + 1) {
                            const payload = {
                                data: {
                                    name: remarks.name,
                                    documents: remarks.documents,
                                    // qpms_user_id: "",
                                    ticket_id: state.StateManagementOverallCall.TicketIDS,
                                    qpms_user_id: state.SideBarFiles.LoginIDs,

                                    // status: "1"

                                },
                                remarks: 1
                            }
                            dispatch(settheticketcreateRetieveDatasActions(payload))
                            setremarts(initialState)
                            setcomment(initialState2)

                            setPresentUrls([])


                            setdosumentuploads(false);
                            seturlandfile([]);
                            setUploadedFiles([]);
                            setremarkspopup(false)
                            setcomment(initialState2)

                        }
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }

                        const data = await response.json();
                        console.log('Files uploaded successfully:', data);
                    }
                } catch (error) {
                    console.error('Error uploading files:', error);
                }
            }));
        };

    if (remarks.name != null && remarks.name != undefined && remarks?.name.trim() != "" || documentnotuploads == true) {
            if (documentnotuploads) {

                fetchUploadFiles()
            }

            else {
                const payload = {
                    data: {
            name: remarks.name?.trim(),
                        documents: remarks.documents,
                        // qpms_user_id: "",
                        ticket_id: state.StateManagementOverallCall.TicketIDS,
                        // status: "1",
                        qpms_user_id: state.SideBarFiles.LoginIDs,



                    },
                    remarks: 1
                }
                dispatch(settheticketcreateRetieveDatasActions(payload))
                setdosumentuploads(false);
                seturlandfile([]);
                setUploadedFiles([]);
                setremarkspopup(false)


                setcomment(initialState2)
                setPresentUrls([])
                setremarts({
                    ...remarks,
                    name: "",
                    documents: []
                })
                // setremarts(initialState)


            }




        }
        else {
            toast.error("Please enter the valid details");
        }


    }
    const HandleTheComments = (E) => {
        if (comment.name !== "") {
            const payload = {
                data: {
                    name: comment.name,
                    ticket_id: state.StateManagementOverallCall.TicketIDS,

                },
                remarks: 2
            }
            dispatch(settheticketcreateRetieveDatasActions(payload))



            setcomment(initialState2)
            // const ticketpay = {
            //     EditID: state.StateManagementOverallCall.TicketIDS,
            //     Rawdata: {
            //         status: "4"
            //     }



            // }
            // dispatch(settehTicketStatusChanges(ticketpay));
            setcommetpoup(false);
            navigate("/ticketlist")
        }
        else {


            toast.info("Please enter the valid details");

        }


    }


    const handletheticketupdated = (value,) => {


        if (value != 1) {
            if (comment.name != "") {
                if (TickeREtrievdatas.over_due == true) {
                    if (ticketactivenames != "") {
                        const ticketpay = {
                            EditID: state.StateManagementOverallCall.TicketIDS,
                            Rawdata: {
                                status: value,
                            },
                            data: {

                                EditID: state.StateManagementOverallCall.TicketIDS
                            }
                        }

                        HandleRemarksWithudsForreview()
                        // dispatch(settehTicketStatusChanges(ticketpay));

                        HandleRemarsks(value, value,) /// for close the tickets
                        setremarkspopup(false);
                    }
                    else {
                        toast.info("Please enter the valid details");


                    }
                }
                else {
                    const ticketpay = {
                        EditID: state.StateManagementOverallCall.TicketIDS,
                        Rawdata: {
                            status: value,
                        },
                        data: {

                            EditID: state.StateManagementOverallCall.TicketIDS
                        }
                    }

                    // dispatch(settehTicketStatusChanges(ticketpay));

                    HandleRemarsks(value, value,) /// for close the tickets
                    setremarkspopup(false);

                }


            }

            else {
                toast.info("Please enter the valid details");

            }
        }


        if (value == 1) {


            const ticketpay = {
                EditID: state.StateManagementOverallCall.TicketIDS,
                Rawdata: {
                    status: value,
                },
                data: {

                    EditID: state.StateManagementOverallCall.TicketIDS
                }
            }
            dispatch(settehTicketStatusChanges(ticketpay)); // ticket updates 
            // if (value == 1) {
            //     const payload = {
            //         data: {
            //             name: "Open to In Progress",
            //             description: "Open to In Progress",
            //             documents: [],
            //             // qpms_user_id: "",
            //             ticket_id: state.StateManagementOverallCall.TicketIDS,
            //             // status: "1",
            //             qpms_user_id: state.SideBarFiles.LoginIDs,



            //         },
            //         remarks: 1
            //     }
            //     dispatch(settheticketcreateRetieveDatasActions(payload))
            // }
            // else if (value == 2) {


            //     const payload = {
            //         data: {
            //             name: "In Progress to Review",
            //             documents: [],
            //             // qpms_user_id: "",
            //             qpms_user_id: state.SideBarFiles.LoginIDs,
            //             ticket_id: state.StateManagementOverallCall.TicketIDS,
            //             // status: "1"


            //         },
            //         // remarks: e == 3 ? 3 : 2,
            //         remarks: 1,
            //         // ticketcall: ticketvalues
            //     }
            //     dispatch(settheticketcreateRetieveDatasActions(payload))

            // }
            setTicketConfirmPopup(false)

        }
    }






    // const capitalizeEachWord = (str) => {
    //     return str
    //         .split(' ') // Split the string into an array of words
    //         .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
    //         .join(' '); // Join the words back into a string
    // };



    const capitalizeEachWord = (str) => {
        return str && typeof str === 'string'
            ? str
                .split(' ') // Split the string into an array of words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
                .join(' ') // Join the words back into a string
            : ''; // Return an empty string if the input is invalid
    };


    const HandleSubmit = (e) => {
        e.preventDefault();
    };
    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };


    // console.log(overdueFunctions(TickeREtrievdatas), "sdofisldkflsd laskdksa;ds;ld asdasd",
    //     TickeREtrievdatas);

    const HanldtheRejectTickets = (e) => {
        const payload = {
            data: {
                ticket_assign_mode: "reject"
            },
            EditId: state.StateManagementOverallCall.TicketIDS,

        }
        dispatch(setthereassignandAssignRejectDataActions(payload))
    }
    const HandleTheAssings = (e) => {
        dispatch(settheAssignAndReassigns(1))
        dispatch(settheTicketStatusNames(TickeREtrievdatas?.status == 0 ? "Open" :
            TickeREtrievdatas?.status == 1 ? "In Progress" :
                TickeREtrievdatas?.status == 2 ? "Review" :
                    TickeREtrievdatas?.status == 3 ? "Resolved" : "Reopened"))

        navigate("/ticket_allocate")
    }

    const HandleTheViewsof = (e) => {
        // dispatch(settheTicketViewIds(state.StateManagementOverallCall.TicketIDS))
        dispatch(settheTicketViewIds(state.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0].id))
        // navigate("/ticket_client_view")
        navigate("/sub_ticket_client_view")
    }

    // const { internal_ticket_serializer } = state.TicketDetailsListedNames.ClientTicketDetailsForInternal;

    // useEffect(() => {
    //     if (state.TicketDetailsListedNames.ClientTicketDetailsForInternal != undefined) {
    //         if (internal_ticket_serializer && (Array.isArray(internal_ticket_serializer)  typeof internal_ticket_serializer === "object")) {
    //             // console.log("assign assign", state.FormsIDList.ActiveTabs);
    //             setStoreexcalated("assign")
    //         } else {
    //             setStoreexcalated("view")

    //             // console.log("view assign", state.FormsIDList.ActiveTabs);
    //         }

    //     }
    // }, [state.TicketDetailsListedNames.ClientTicketDetailsForInternal])
    const { internal_ticket_serializer } = state.TicketDetailsListedNames.ClientTicketDetailsForInternal || {};

    useEffect(() => {
        if (state.TicketDetailsListedNames.ClientTicketDetailsForInternal !== undefined) {
            console.log(Array.isArray(internal_ticket_serializer), "qwpoueopqwioep q");

            if (Array.isArray(internal_ticket_serializer)) {
                setStoreexcalated("view");
                if (internal_ticket_serializer.length > 0) {
                    dispatch(settheExternalTicketviewslisted(internal_ticket_serializer[0].id))
                }
            } else {
                setStoreexcalated("assign");
            }
        }
    }, [state.TicketDetailsListedNames.ClientTicketDetailsForInternal]);


    // console.log(StoretheEscalate, StoretheEscalate == "view", "state.FormsIDList.ActiveTabs", TickeREtrievdatas?.status);


    return (
        <>
            <div className={`TicketingSytemview ${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
                <div className="col BodyContent LeaveEdits TicketSystem">
                    <div className="card CardContent">
                        <div className="card-body cards ">
                            <div className="UserPoup">
                                <div className="BeforForms">
                                    <div className="Form">
                                        <div className="ModalHeader">
                                            <span>Ticket Details  </span>
                                            <div
                                                className="CloseIcon"
                                                onClick={() => {
                                                    if (state.NeededdatasListed.RoutesDefinedof == 3) {
                                                        navigate("/neardue_client")
                                                    }
                                                    else if (state.NeededdatasListed.RoutesDefinedof == 1) {
                                                        navigate("/ticketdashboard")
                                                    }
                                                    else {
                                                        navigate("/ticketlist")
                                                    }
                                                }}
                                            >
                                                {/* <CloseOutlinedIcon /> */}
                                                <button className='CloseButtonsofTicketViews'>
                                                    <span className='BackOfTicketViewsButon'>
                                                        <img src={closeticketviews} />
                                                        <span>Back</span>
                                                    </span>
                                                </button>

                                            </div>
                                        </div>
                                        <div className="Modal-Body Modal-bodyTracking">
                                            <div className='row InnerFormsDetails InnerFormsDetailsviews'>

                                                <div className="col-7">


                                                    <div className='TicketDetailsOverallCard'>
                                                        <div className="card CardBox ">
                                                            <div className='HeaderTimelines HeaderofClientList'>
                                                                <div className='HeaderHeadingClientname'>
                                                                    <div className='InnerClientCrendials'>
                                                                        <div className='clientimgs'>
                                                                            <img src={profile2} />
                                                                        </div>

                                                                        <div className='ClientLableForms'>
                                                                            <div className='CardofLabels'>

                                                                                <h6>{TickeREtrievdatas?.client_id?.client_name ?
                                                                                    truncateText(capitalizeEachWord(TickeREtrievdatas?.client_id?.client_name.toLowerCase()), 40)
                                                                                    : ""}

                                                                                </h6>

                                                                            </div>

                                                                            <div className='InnerTimelabel'

                                                                                style={{
                                                                                    backgroundColor:
                                                                                        TickeREtrievdatas?.priority === "2"
                                                                                            ? "red"
                                                                                            : TickeREtrievdatas?.priority === "1"
                                                                                                ? "#234492"
                                                                                                : TickeREtrievdatas?.priority === "0"
                                                                                                    ? "#234492"
                                                                                                    : "transparent",
                                                                                }}

                                                                            >
                                                                                {TickeREtrievdatas?.priority === "0"
                                                                                    ? "LOW PRIORITY"
                                                                                    : TickeREtrievdatas?.priority === "1"
                                                                                        ? "MEDIUM PRIORITY"
                                                                                        : TickeREtrievdatas?.priority === "2"
                                                                                            ? "HIGH PRIORITY"
                                                                                            : "---"}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className='ClientNames'>
                                                                        <div className='ClientUserNames'>
                                                                            <span>{TickeREtrievdatas?.client_user_id?.first_name ? capitalizeEachWord(TickeREtrievdatas?.client_user_id?.first_name.toLowerCase()) : ""}

                                                                                <span>{"Created Date"}{TickeREtrievdatas?.created_at ? formatDateTime(TickeREtrievdatas?.created_at) : ""}</span>
                                                                            </span>
                                                                        </div>
                                                                    </div> */}

                                                                    <div className='ClientNames'>
                                                                        <div className='ClientUserNames'>
                                                                            <div className='ClientDeatilsRecords'>
                                                                                <div

                                                                                    onMouseEnter={() => setShowToolPhone(true)}
                                                                                    onMouseLeave={() => setShowToolPhone(false)}
                                                                                >
                                                                                    <img src={phoneimg} />
                                                                                </div>

                                                                                {showToolphone && (
                                                                                    <div className="custom-tooltip">
                                                                                        <span>{TickeREtrievdatas?.client_user_id?.phone_number || 'No Phone Number Available'}</span>
                                                                                    </div>
                                                                                )}

                                                                                <span>{TickeREtrievdatas?.client_user_id?.first_name ? capitalizeEachWord(TickeREtrievdatas?.client_user_id?.first_name.toLowerCase()) : ""}</span>


                                                                            </div>  <span className='Createddate Createddatetickets'>{" Created : "}
                                                                                <span className='DateFill' >
                                                                                    {TickeREtrievdatas?.created_at ? formatedDateListwithouttime(TickeREtrievdatas?.created_at) : ""}
                                                                                </span>
                                                                            </span>

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>


                                                        </div>


                                                        <div className="col-5 Recentcard mb-3">
                                                            <div className="card  ProgressionsCards " >
                                                                <div className='HeaderTimelines'>
                                                                    <div className='HeaderHeading'>
                                                                        <h5>Progression</h5>
                                                                        {/* <button>

                                                                            {(() => {
                                                                                const createdAt = TickeREtrievdatas?.created_at;
                                                                                if (createdAt) {
                                                                                    const createdDate = new Date(createdAt);
                                                                                    const currentDate = new Date();
                                                                                    const timeDifference = currentDate - createdDate; // Difference in milliseconds
                                                                                    const daysLeft = Math.max(0, Math.ceil(timeDifference / (1000 * 60 * 60 * 24))); // Convert to days
                                                                                    return `${daysLeft} days left`;
                                                                                }
                                                                                return "No date available";
                                                                            })()}

                                                                        </button> */}

                                                                        {/* {TickeREtrievdatas?.over_due_date != null && TickeREtrievdatas?.over_due_date != undefined && TickeREtrievdatas?.status != undefined && TickeREtrievdatas?.status != 3 ?
                                                                            <span className="progression-due-date">Due Date
                                                                                {TickeREtrievdatas?.over_due_date ? formatDate(TickeREtrievdatas?.over_due_date) : "  --"}
                                                                            </span>
                                                                            : null} */}

                                                                    </div>

                                                                </div>
                                                                {/* <div className='ProgressInoverall'>

                                                                    <div className='InnerProgressionLable'>

                                                                        <div className='InnerTimelabel'

                                                                            style={{
                                                                                background: TickeREtrievdatas?.status === 0
                                                                                    ? "#234492" // Open - dark red background
                                                                                    : TickeREtrievdatas?.status === 1
                                                                                        ? "hsla(32, 92%, 59%, 1)" // In Progress - dark yellow background
                                                                                        : TickeREtrievdatas?.status === 2
                                                                                            ? "hsla(170, 75%, 41%, 1)" // Completed - dark green background
                                                                                            : TickeREtrievdatas?.status === 3
                                                                                                ? "hsla(140, 82%, 39%, 1)" // Close - darker green background for Close
                                                                                                : "#234492", // Default for Reopen - dark red background
                                                                                color: "#fff",
                                                                            }}

                                                                        >
                                                                            {TickeREtrievdatas?.status == 0 ? "Open" :
                                                                                TickeREtrievdatas?.status == 1 ? "In progress" :
                                                                                    TickeREtrievdatas?.status == 2 ? "Review" :
                                                                                        TickeREtrievdatas?.status == 3 ? "Resolved" : "Reopen"}
                                                                        </div>
                                                                    </div>
                                                                    <div className="progress-TIMELINE">

                                                                        {StepTickets.map(([status, data], index) => {
                                                                            const isActive = data !== null;
                                                                            return (
                                                                                <React.Fragment key={status}>
                                                                                    <div className={`step ${isActive ? "active" : "notActivebars"}`}>
                                                                                        <div className="circle" />
                                                                                        <div className={`label ${isActive ? "active" : ""}`}>
                                                                                            {status == "completed" ? "Review" : status == "close" ? "Resolved" : capitalizeEachWord(status)}
                                                                                            <br />
                                                                                            <span className='DateFiles'> {data?.created_date
                                                                                                ? formatDatefeed(data?.created_date)
                                                                                                : "   "}</span>
                                                                                        </div>

                                                                                    </div>
                                                                                    {index < StepTickets.length - 1 && (
                                                                                        <div className={`line ${isActive ? "active" : ""}`} />
                                                                                    )}
                                                                                </React.Fragment>
                                                                            );
                                                                        })}


                                                                    </div>
                                                                </div> */}

                                                                <div className="progression-container">

                                                                    <div className="progression-body">
                                                                        <div className="status">
                                                                            <span className="status-label open"
                                                                                style={{
                                                                                    background: TickeREtrievdatas?.status == 0 ? "#FDEDE9" : // Open - light background
                                                                                        TickeREtrievdatas?.status == 1 ? "#FFF8E5" : // In Progress - yellow background
                                                                                            TickeREtrievdatas?.status == 2 ? "#E7F8ED" : // Completed - light green background
                                                                                                TickeREtrievdatas?.status == 3 ? "#DFFFE3" : // Close - light green background for Close
                                                                                                    "#FFDDDD", // Default for Reopen - light red background
                                                                                    color: TickeREtrievdatas?.status == 0 ? "#ED4C28" : // Open - red text
                                                                                        TickeREtrievdatas?.status == 1 ? "#FFB800" : // In Progress - yellow text
                                                                                            TickeREtrievdatas?.status == 2 ? "#12B749" : // Completed - green text
                                                                                                TickeREtrievdatas?.status == 3 ? "#8BC34A" : // Close - light green text for Close
                                                                                                    "#ED4C28", // Default for Reopen - red text
                                                                                }}

                                                                            >

                                                                                {TickeREtrievdatas?.status == 0 ? "Open" :
                                                                                    TickeREtrievdatas?.status == 1 ? "In Progress" :
                                                                                        TickeREtrievdatas?.status == 2 ? "Review" :
                                                                                            TickeREtrievdatas?.status == 3 ? "Resolved" : "Reopened"}


                                                                            </span>


                                                                            {/* <span className="days-left">
                                                                              
                                                                                <span className='days-count'>2</span>
                                                                            </span> */}
                                                                            {/* <CircularProgressWithLabel value={2} /> */}
                                                                            {/* <div class="circular-progress">
                                                                                <div class="circle">
                                                                                    <div class="number">02</div>
                                                                                    <div class="text">Days left</div>
                                                                                </div>
                                                                            </div> */}
                                                                            {/* {TickeREtrievdatas?.status != 3 ?
                                                                                <p className='HeaderoftheDatefiledsName'>
                                                                                    {overdueFunctions(TickeREtrievdatas)}
                                                                                </p>
                                                                                : null} */}

                                                                            {TickeREtrievdatas?.status != undefined && TickeREtrievdatas?.status != 3 ?
                                                                                // <p className="HeaderoftheDatefileds">
                                                                                //     <span className="HeaderoftheDatefiledsName">
                                                                                //         {(() => {
                                                                                //             const response = overdueFunctions(TickeREtrievdatas); // Get the response

                                                                                //             if (response) {
                                                                                //                 // Check for specific time-related keywords
                                                                                //                 if (response.includes("Minutes left")) {
                                                                                //                     const minutes = response.split("Minutes left")[0].trim();
                                                                                //                     return <>{`Minutes left`}</>
                                                                                //                 } else if (response.includes("Hours left")) {
                                                                                //                     const hours = response.split("Hours left")[0].trim();
                                                                                //                     return <>{`Hours left`}</>
                                                                                //                 } else if (response.includes("Days left")) {
                                                                                //                     const days = response.split("Days left")[0].trim();
                                                                                //                     return <>{`Days left`}</>
                                                                                //                 } else if (response === "Overdue") {
                                                                                //                     return <>Overdue</>
                                                                                //                 }
                                                                                //             }

                                                                                //             return response; // Default rendering if "Minutes left" is not in the response
                                                                                //         })()}
                                                                                //     </span>
                                                                                //     {overdueFunctions(TickeREtrievdatas) != "Overdue" ?
                                                                                //         <Stack spacing={2} direction="row">
                                                                                //             <CircularProgress variant="determinate"
                                                                                //                 // value={90}
                                                                                //                 value={
                                                                                //                     (() => {
                                                                                //                         const response = overdueFunctions(TickeREtrievdatas); // Get the response
                                                                                //                         let percentage = 0; // Default to 0

                                                                                //                         if (response && response.includes("Minutes left")) {
                                                                                //                             const [minutesText, ...rest] = response.split("Minutes left"); // Split the response
                                                                                //                             // Extract the remaining time from the text (in minutes)
                                                                                //                             const minutesLeft = rest.join("");
                                                                                //                             console.log(minutesLeft, "spdooisad minutesLeft");

                                                                                //                             // Ensure the minutesLeft is a valid number
                                                                                //                             if (isNaN(minutesLeft)) {
                                                                                //                                 console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                //                                 return percentage; // Return 0 if invalid
                                                                                //                             }

                                                                                //                             const totalTAT = TickeREtrievdatas?.client_id?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                //                             // Ensure the totalTAT is a valid number
                                                                                //                             if (isNaN(totalTAT)) {
                                                                                //                                 console.error("Invalid totalTAT value:", totalTAT);
                                                                                //                                 return percentage; // Return 0 if invalid
                                                                                //                             }
                                                                                //                             if (totalTAT === 1) {
                                                                                //                                 // Directly use minutesLeft as a percentage of 100
                                                                                //                                 percentage = Math.min(minutesLeft, 100);
                                                                                //                             } else {
                                                                                //                                 // Use the usual percentage formula
                                                                                //                                 percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                //                             }
                                                                                //                             // percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                //                         }
                                                                                //                         else if (response && response.includes("Hours left")) {
                                                                                //                             const [minutesText, ...rest] = response.split("Hours left"); // Split the response
                                                                                //                             // Extract the remaining time from the text (in minutes)
                                                                                //                             // const minutesLeft = rest.join("");
                                                                                //                             const minutesLeft = parseInt(minutesText.trim(), 10); // Extract the minutes value
                                                                                //                             console.log(minutesLeft, "spdooisad minutesLeft");

                                                                                //                             // Ensure the minutesLeft is a valid number
                                                                                //                             if (isNaN(minutesLeft)) {
                                                                                //                                 console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                //                                 return percentage; // Return 0 if invalid
                                                                                //                             }

                                                                                //                             const totalTAT = TickeREtrievdatas?.client_id?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                //                             // Ensure the totalTAT is a valid number
                                                                                //                             if (isNaN(totalTAT)) {
                                                                                //                                 console.error("Invalid totalTAT value:", totalTAT);
                                                                                //                                 return percentage; // Return 0 if invalid
                                                                                //                             }

                                                                                //                             // Calculate percentage (ensure it does not exceed 100)
                                                                                //                             percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                //                         }

                                                                                //                         else if (response && response.includes("Days left")) {
                                                                                //                             const [minutesText, ...rest] = response.split("Days left"); // Split the response
                                                                                //                             // Extract the remaining time from the text (in minutes)
                                                                                //                             // const minutesLeft = rest.join("");
                                                                                //                             const minutesLeft = parseInt(minutesText.trim(), 10); // Extract the minutes value
                                                                                //                             console.log(minutesLeft, "spdooisad minutesLeft");

                                                                                //                             // Ensure the minutesLeft is a valid number
                                                                                //                             if (isNaN(minutesLeft)) {
                                                                                //                                 console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                //                                 return percentage; // Return 0 if invalid
                                                                                //                             }

                                                                                //                             const totalTAT = TickeREtrievdatas?.client_id?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                //                             // Ensure the totalTAT is a valid number
                                                                                //                             if (isNaN(totalTAT)) {
                                                                                //                                 console.error("Invalid totalTAT value:", totalTAT);
                                                                                //                                 return percentage; // Return 0 if invalid
                                                                                //                             }

                                                                                //                             // Calculate percentage (ensure it does not exceed 100)
                                                                                //                             percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                //                         }


                                                                                //                         return percentage; // Return calculated percentage for CircularProgress
                                                                                //                     })()
                                                                                //                 }

                                                                                //                 style={{ borderRadius: "50%", background: "#ED4C2833" }}
                                                                                //             />
                                                                                //             <span className={`TicketDatestatus `}>
                                                                                //                 {(() => {
                                                                                //                     const response = overdueFunctions(TickeREtrievdatas); // Get the response

                                                                                //                     if (response) {
                                                                                //                         if (response.includes("Minutes left")) {
                                                                                //                             const [minutesText, ...rest] = response.split("Minutes left"); // Split the response for minutes
                                                                                //                             const minutesLeft = parseInt(minutesText.trim(), 10); // Extract the minutes value



                                                                                //                             return (
                                                                                //                                 <>
                                                                                //                                     <>
                                                                                //                                         {rest.length > 0 && <span className="OtherText">{rest.join("")}</span>}
                                                                                //                                     </>

                                                                                //                                 </>
                                                                                //                             );
                                                                                //                         }

                                                                                //                         if (response.includes("Hours left")) {
                                                                                //                             const [hoursText, ...rest] = response.split("Hours left"); // Split the response for hours
                                                                                //                             const hoursLeft = parseInt(hoursText.trim(), 10); // Extract the hours value

                                                                                //                             console.log(hoursLeft, rest.join(""), "afpasoidaosdrest");

                                                                                //                             return (
                                                                                //                                 <>
                                                                                //                                     {/* {rest.length > 0 && <span className="OtherText">{rest.join("")}</span>} */}
                                                                                //                                     <span className="OtherText">{hoursLeft}</span>


                                                                                //                                 </>
                                                                                //                             );
                                                                                //                         }

                                                                                //                         if (response.includes("Days left")) {
                                                                                //                             const [daysText, ...rest] = response.split("Days left"); // Split the response for days
                                                                                //                             const daysLeft = parseInt(daysText.trim(), 10); // Extract the days value
                                                                                //                             return (
                                                                                //                                 <>
                                                                                //                                     {daysLeft != undefined && <span className="OtherText">{daysLeft}</span>}

                                                                                //                                 </>
                                                                                //                             );
                                                                                //                         }
                                                                                //                     }

                                                                                //                     return response; // Default rendering if none of the conditions match
                                                                                //                 })()}



                                                                                //             </span>
                                                                                //         </Stack>
                                                                                //         : null}


                                                                                // </p>
                                                                                <p className="HeaderoftheDatefileds Dashboardneardues">


                                                                                    {overdueFunctions(TickeREtrievdatas) != "Overdue" ?
                                                                                        <Stack spacing={2} direction="row">
                                                                                            <CircularProgress variant="determinate"

                                                                                                // value={90}

                                                                                                // value={
                                                                                                //     (() => {
                                                                                                //         const response = overdueFunctions(item); // Get the response
                                                                                                //         let percentage = 0; // Default to 0

                                                                                                //         if (response && response.includes("Minutes left")) {
                                                                                                //             const [minutesText, ...rest] = response.split("Minutes left"); // Split the response
                                                                                                //             // Extract the remaining time from the text (in minutes)
                                                                                                //             const minutesLeft = rest.join("");
                                                                                                //             console.log(minutesLeft, "spdooisad minutesLeft");

                                                                                                //             // Ensure the minutesLeft is a valid number
                                                                                                //             if (isNaN(minutesLeft)) {
                                                                                                //                 console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                //                 return percentage; // Return 0 if invalid
                                                                                                //             }

                                                                                                //             const totalTAT = item?.client_id?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                                //             // Ensure the totalTAT is a valid number
                                                                                                //             if (isNaN(totalTAT)) {
                                                                                                //                 console.error("Invalid totalTAT value:", totalTAT);
                                                                                                //                 return percentage; // Return 0 if invalid
                                                                                                //             }

                                                                                                //             // Calculate percentage (ensure it does not exceed 100)
                                                                                                //             percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                //         }
                                                                                                //         else if (response && response.includes("Hours left")) {
                                                                                                //             const [minutesText, ...rest] = response.split("Hours left"); // Split the response
                                                                                                //             // Extract the remaining time from the text (in minutes)
                                                                                                //             const minutesLeft = rest.join("");
                                                                                                //             console.log(minutesLeft, "spdooisad minutesLeft");

                                                                                                //             // Ensure the minutesLeft is a valid number
                                                                                                //             if (isNaN(minutesLeft)) {
                                                                                                //                 console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                //                 return percentage; // Return 0 if invalid
                                                                                                //             }

                                                                                                //             const totalTAT = item?.client_id?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                                //             // Ensure the totalTAT is a valid number
                                                                                                //             if (isNaN(totalTAT)) {
                                                                                                //                 console.error("Invalid totalTAT value:", totalTAT);
                                                                                                //                 return percentage; // Return 0 if invalid
                                                                                                //             }

                                                                                                //             // Calculate percentage (ensure it does not exceed 100)
                                                                                                //             percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                //         }

                                                                                                //         else if (response && response.includes("Days left")) {
                                                                                                //             const [minutesText, ...rest] = response.split("Days left"); // Split the response
                                                                                                //             // Extract the remaining time from the text (in minutes)
                                                                                                //             const minutesLeft = rest.join("");
                                                                                                //             console.log(minutesLeft, "spdooisad minutesLeft");

                                                                                                //             // Ensure the minutesLeft is a valid number
                                                                                                //             if (isNaN(minutesLeft)) {
                                                                                                //                 console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                //                 return percentage; // Return 0 if invalid
                                                                                                //             }

                                                                                                //             const totalTAT = item?.client_id?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                                //             // Ensure the totalTAT is a valid number
                                                                                                //             if (isNaN(totalTAT)) {
                                                                                                //                 console.error("Invalid totalTAT value:", totalTAT);
                                                                                                //                 return percentage; // Return 0 if invalid
                                                                                                //             }

                                                                                                //             // Calculate percentage (ensure it does not exceed 100)
                                                                                                //             percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                //         }

                                                                                                //         console.log(percentage, "ioSAIOSU percentage",overdueFunctions(item));

                                                                                                //         return percentage; // Return calculated percentage for CircularProgress
                                                                                                //     })()
                                                                                                // }
                                                                                                value={
                                                                                                    // (() => {
                                                                                                    //     const response = overdueFunctions(item); // Get the response
                                                                                                    //     let percentage = 0; // Default to 0

                                                                                                    //     if (response && response.includes("Minutes left")) {
                                                                                                    //         const [minutesText, ...rest] = response.split("Minutes left"); // Split the response
                                                                                                    //         // Extract the remaining time from the text (in minutes)
                                                                                                    //         const minutesLeft = rest.join("");
                                                                                                    //         console.log(minutesLeft, "spdooisad minutesLeft");

                                                                                                    //         // Ensure the minutesLeft is a valid number
                                                                                                    //         if (isNaN(minutesLeft)) {
                                                                                                    //             console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                    //             return percentage; // Return 0 if invalid
                                                                                                    //         }

                                                                                                    //         const totalTAT = item?.client_id?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                                    //         // Ensure the totalTAT is a valid number
                                                                                                    //         if (isNaN(totalTAT)) {
                                                                                                    //             console.error("Invalid totalTAT value:", totalTAT);
                                                                                                    //             return percentage; // Return 0 if invalid
                                                                                                    //         }

                                                                                                    //         // Calculate percentage (ensure it does not exceed 100)
                                                                                                    //         percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                    //     }
                                                                                                    //     else if (response && response.includes("Hours left")) {
                                                                                                    //         const [minutesText, ...rest] = response.split("Hours left"); // Split the response
                                                                                                    //         // Extract the remaining time from the text (in minutes)
                                                                                                    //         // const minutesLeft = rest.join("");
                                                                                                    //         const minutesLeft = parseInt(minutesText.trim(), 10); // Extract the minutes value
                                                                                                    //         console.log(minutesLeft, "spdooisad minutesLeft");

                                                                                                    //         // Ensure the minutesLeft is a valid number
                                                                                                    //         if (isNaN(minutesLeft)) {
                                                                                                    //             console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                    //             return percentage; // Return 0 if invalid
                                                                                                    //         }

                                                                                                    //         const totalTAT = item?.client_id?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                                    //         // Ensure the totalTAT is a valid number
                                                                                                    //         if (isNaN(totalTAT)) {
                                                                                                    //             console.error("Invalid totalTAT value:", totalTAT);
                                                                                                    //             return percentage; // Return 0 if invalid
                                                                                                    //         }

                                                                                                    //         // Calculate percentage (ensure it does not exceed 100)
                                                                                                    //         percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                    //     }

                                                                                                    //     else if (response && response.includes("Days left")) {
                                                                                                    //         const [minutesText, ...rest] = response.split("Days left"); // Split the response
                                                                                                    //         // Extract the remaining time from the text (in minutes)
                                                                                                    //         // const minutesLeft = rest.join("");
                                                                                                    //         const minutesLeft = parseInt(minutesText.trim(), 10); // Extract the minutes value
                                                                                                    //         console.log(minutesLeft, "spdooisad minutesLeft");

                                                                                                    //         // Ensure the minutesLeft is a valid number
                                                                                                    //         if (isNaN(minutesLeft)) {
                                                                                                    //             console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                    //             return percentage; // Return 0 if invalid
                                                                                                    //         }

                                                                                                    //         const totalTAT = item?.client_id?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                                    //         // Ensure the totalTAT is a valid number
                                                                                                    //         if (isNaN(totalTAT)) {
                                                                                                    //             console.error("Invalid totalTAT value:", totalTAT);
                                                                                                    //             return percentage; // Return 0 if invalid
                                                                                                    //         }

                                                                                                    //         // Calculate percentage (ensure it does not exceed 100)
                                                                                                    //         percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                    //     }


                                                                                                    //     return percentage; // Return calculated percentage for CircularProgress
                                                                                                    // })()
                                                                                                    (() => {
                                                                                                        const response = overdueFunctions(TickeREtrievdatas); // Get the response
                                                                                                        let percentage = 0; // Default to 0


                                                                                                        if (response && response.includes("Minutes left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Minutes left"); // Split the response
                                                                                                            // Extract the remaining time from the text (in minutes)
                                                                                                            const minutesLeft = Number(rest.join(""));
                                                                                                            const totalTAT = TickeREtrievdatas?.client_id?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                                            console.log(minutesLeft, typeof minutesLeft, isNaN(minutesLeft), "oasiudopasidopaisd minutesLeft", totalTAT, minutesLeft, Math.min((minutesLeft / totalTAT) * 100, 100));


                                                                                                            // Ensure the minutesLeft is a valid number
                                                                                                            if (isNaN(minutesLeft)) {
                                                                                                                console.error("Invalid minutesLeft value:");
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }


                                                                                                            if (isNaN(totalTAT)) {
                                                                                                                console.error("Invalid totalTAT value:", totalTAT);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }
                                                                                                            if (totalTAT === 1) {
                                                                                                                // Directly use minutesLeft as a percentage of 100
                                                                                                                percentage = Math.min(minutesLeft, 100);
                                                                                                            } else {
                                                                                                                // Use the usual percentage formula
                                                                                                                percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                            }

                                                                                                            // percentage = Math.min((minutesLeft / totalTAT ) * 100, 100);
                                                                                                        }
                                                                                                        else if (response && response.includes("Hours left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Hours left");
                                                                                                            const minutesLeft = parseInt(minutesText.trim(), 10);

                                                                                                            if (isNaN(minutesLeft)) {
                                                                                                                console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }

                                                                                                            const totalTAT = TickeREtrievdatas?.client_id?.l1_user_TAT || 100;
                                                                                                            if (isNaN(totalTAT)) {
                                                                                                                console.error("Invalid totalTAT value:", totalTAT);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }

                                                                                                            percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                        }

                                                                                                        else if (response && response.includes("Days left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Days left");
                                                                                                            const minutesLeft = parseInt(minutesText.trim(), 10);
                                                                                                            if (isNaN(minutesLeft)) {
                                                                                                                console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }

                                                                                                            const totalTAT = TickeREtrievdatas?.client_id?.l1_user_TAT || 100;
                                                                                                            if (isNaN(totalTAT)) {
                                                                                                                return percentage;
                                                                                                            }
                                                                                                            percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                        }

                                                                                                        console.log(percentage, "aspdopasidoasd percentage", response);

                                                                                                        return percentage;
                                                                                                    })()
                                                                                                }
                                                                                                style={{
                                                                                                    borderRadius: "50%",
                                                                                                    width: "59px",
                                                                                                    height: "60px",
                                                                                                    background: "transparent", // Conditional background color based on the value
                                                                                                    // border: "2px solid", // Ensure a border is present
                                                                                                    borderColor: "#234492",
                                                                                                    color: "#234492",
                                                                                                    marginRight: "-16px !important"
                                                                                                    // color: 10 === 90 ? "#234492" : "gray", // Conditional border color based on the value
                                                                                                    // borderColor: overdueFunctionspercentanges(item) >10 ? "#234492" : "gray", // Conditional border color based on the value
                                                                                                }}

                                                                                                sx={{
                                                                                                    borderRadius: "50%",
                                                                                                    width: "55px",
                                                                                                    height: "55px",
                                                                                                    backgroundColor: "transparent", // Conditional background color
                                                                                                    // border: "2px solid", // Border width
                                                                                                    borderColor: 90 === 90 ? "#234492" : "gray", // Conditional border color
                                                                                                }}


                                                                                            //  sx={(theme) => ({
                                                                                            //     color: theme.palette.grey[200],
                                                                                            //     ...theme.applyStyles('#234492', {
                                                                                            //       color: theme.palette.grey[800],
                                                                                            //     }),
                                                                                            //   })}

                                                                                            />

                                                                                            <span className="HeaderoftheDatefiledsNameDashboard">
                                                                                                {(() => {
                                                                                                    const response = overdueFunctions(TickeREtrievdatas); // Get the response

                                                                                                    if (response) {
                                                                                                        // Check for specific time-related keywords
                                                                                                        if (response.includes("Minutes left")) {
                                                                                                            // const minutes = response.split("Minutes left")[0].trim();
                                                                                                            const [minutesText, ...rest] = response.split("Minutes left"); // Split the response

                                                                                                            return <> <span>{rest.join("")}</span><span className="MinutesLeft">

                                                                                                                {"Minutes"}</span></>


                                                                                                        } else if (response.includes("Hours left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Hours left"); // Split the response
                                                                                                            const daysLeft = parseInt(minutesText.trim(), 10); // Extract the days value

                                                                                                            // const hours = response.split("Hours left")[0].trim();

                                                                                                            // return <span className="HoursLeft">{daysLeft}<br />{"Hours"}</span>;

                                                                                                            return <> <span>{daysLeft}</span><span className="MinutesLeft">

                                                                                                                {"Hours"}</span></>
                                                                                                        } else if (response.includes("Days left")) {
                                                                                                            // const days = response.split("Days left")[0].trim();
                                                                                                            const [minutesText, ...rest] = response.split("Days left"); // Split the response
                                                                                                            const daysLeft = parseInt(minutesText.trim(), 10); // Extract the days value
                                                                                                            // return <span className="DaysLeft">{`Days  ${daysLeft}`}</span>;
                                                                                                            // return <span className="HoursLeft">{daysLeft}<br />{"Days"}</span>;

                                                                                                            return <> <span>{daysLeft}</span><span className="MinutesLeft">

                                                                                                                {"Days"}</span></>

                                                                                                        } else if (response === "Overdue") {
                                                                                                            return <span className="OverdueText">Overdue</span>;
                                                                                                        }
                                                                                                    }

                                                                                                    return null; // Render nothing if response is not defined
                                                                                                })()}

                                                                                            </span>
                                                                                        </Stack>
                                                                                        :
                                                                                        <span className="OverdueTextticket">Overdue</span>}


                                                                                </p>
                                                                                : null}

                                                                        </div>

                                                                        {/* <TimelineExample /> */}

                                                                        <div className="timeline-containers timeline-containersprogress">


                                                                            {state.ticketTimeLIneSlicedata.TicketTimeLinerecords && Object.keys(state.ticketTimeLIneSlicedata.TicketTimeLinerecords).map((key, index) => {
                                                                                const item = state.ticketTimeLIneSlicedata.TicketTimeLinerecords[key]; // Get the status object (e.g., open, inprogress, etc.)
                                                                                const getStatusText = (statusObj, statusKey) => {
                                                                                    if (statusObj) {
                                                                                        return (
                                                                                            <>
                                                                                                <span>
                                                                                                    {statusObj.created_date
                                                                                                        ? `${new Date(statusObj.created_date).toLocaleDateString("en-GB", {
                                                                                                            day: "2-digit",
                                                                                                            month: "short",
                                                                                                            year: "numeric",
                                                                                                        }).replace(",", "")}`
                                                                                                        : " "}
                                                                                                </span>
                                                                                            </>
                                                                                        );
                                                                                    }

                                                                                };


                                                                                return (

                                                                                    <React.Fragment key={index}>
                                                                                        <div className={`timeline-item ${item?.created_date ? "active" : "NotactiveInBars"}`}>
                                                                                            <div className={`InnerTimelines ${item?.created_date ? "active" : ""}`}>
                                                                                                <div className="dot"></div>
                                                                                                <span>
                                                                                                    {/* {key == "completed" ? "Review" : key == "close" ? "Resolved" : capitalizeEachWord(key)} */}
                                                                                                    {item?.status != null &&
                                                                                                        capitalizeEachWord(item?.status)}


                                                                                                </span>
                                                                                            </div>
                                                                                            <div className={`timeline-line ${item?.created_date ? "active" : ""}`}></div>

                                                                                            <p className='CreatedDateList'>
                                                                                                <span>{getStatusText(item, key)}</span>

                                                                                                <span>{item.created_date ? extractTimeFromDate(item.created_date) : ""}</span>
                                                                                            </p>
                                                                                        </div>
                                                                                    </React.Fragment>

                                                                                );
                                                                            })}








                                                                        </div>
                                                                    </div>
                                                                </div>






                                                            </div>

                                                            <div className="card CardBox  collapseOnecards  shadow-sm  ">


                                                                <div class="accordion" id="accordionExample" style={{ marginTop: "11px" }}>
                                                                    <div class="card  ">
                                                                        <div
                                                                            class="card-header InnerTicketAccordion"
                                                                            id="headingOne"
                                                                            data-bs-toggle="collapse"
                                                                            data-bs-target="#collapseOne"
                                                                            aria-expanded="true"
                                                                            aria-controls="collapseOne"
                                                                                                                          onClick={() => setIsOpen(!isOpen)}

                                                                        >
                                                                            <h5 class="mb-0 HfiveHeaders">



                                                                                <button
                                                                                    class="btn btn-link d-flex justify-content-between align-items-center"
                                                                                    type="button"
                                                                                >


                                                                                    <span class="icon">
                                                                                        <img
                                                                                            src={tciketimgs}
                                                                                            style={{ marginRight: "12px", marginTop: "-2px" }}
                                                                                        />
                                                                                    </span>

                                                                                    Ticket ID - {TickeREtrievdatas?.ticket_number}

                                                                                </button>

        <span className={`icon Icon_rotate ${isOpen ? "rotate_" : ""}`}>
                                            <img src={dropdowns} />
                                          </span>

                                                                            </h5>
                                                                        </div>

                                                                        <div
                                                                            id="collapseOne"
                                                                            // class="collapse show"
                                                                            aria-labelledby="headingOne"
                                                                            data-bs-parent="#accordionExample"
                                                                            className={`collapse ${TickeREtrievdatas?.status == 2 ? "hide_ticket" : "show"}`}

                                                                        >
                                                                            <div class="card-body TicketCardAccordion">
                                                                                <div className='card shadow-sm p-3 '>


                                                                                    <p className="mb-1 cardpara heaerspara">
                                                                                        <span className="ticketheader ticketheadercards">Ticket ID</span>
                                                                                        {TickeREtrievdatas?.ticket_number}
                                                                                    </p>

                                                                                    <p className="mb-1 cardpara heaerspara">
                                                                                        <span className="ticketheader ticketheadercards">Issue Category</span>
                                                                                        <span className='IssueCategorylisted'>
                                                                                            {TickeREtrievdatas?.clientsub_category_id?.issue_id?.name
                                                                                                ? capitalizeEachWord(TickeREtrievdatas?.clientsub_category_id?.issue_id?.name.toLowerCase())
                                                                                                : "--"}
                                                                                        </span>
                                                                                    </p>
                                                                                    <p className="mb-1 cardpara heaerspara">
                                                                                        <span className="ticketheader ticketheadercards">Subcategory</span>
                                                                                        {TickeREtrievdatas?.clientsub_category_id?.name
                                                                                            ? capitalizeEachWord(TickeREtrievdatas?.clientsub_category_id?.name.toLowerCase())
                                                                                            : "---"}
                                                                                    </p>
                                                                                    <p className="mb-1 cardpara">
                                                                                        <span className="ticketheader ticketheadercards">Description</span>
                                                                                        {/* <textarea className='ticketsinners'
                                                                        // value={`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`}
                                                                        value={TickeREtrievdatas?.remarks || "No description available"}
                                                                        disabled>
                                                                    </textarea> */}

                                   
                                       <div className={` ticketsinners RemarksDetails ${expanded ? "expanded" : ""}`}>
      {displayText || "No description available"}{" "}
      {shouldTruncate && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="toggle-btn"
        >
          {expanded ? "Read less" : "Read more"}
        </button>
      )}
    </div>
                                                                                    </p>
                                                                                    {/* {TickeREtrievdatas?.documents == undefined || TickeREtrievdatas?.documents == null ||
                                                                    TickeREtrievdatas?.documents.length == 0 ? null : */}
                                                                                    <p className="mb-1 cardpara">
                                                                                        <span className='ticketheader ticketheadercards Attachmentviedetails '>Attachment</span>

                                                                                        {TickeREtrievdatas?.documents == undefined || TickeREtrievdatas?.documents == null || TickeREtrievdatas?.documents.length === 0 ? (
                                                                                            <p className='NoDouments'>No documents available</p>
                                                                                        ) : (
                                                                                            <div className="document-display">
                                                                                                <div className="document-item">
                                                                                                    {/* Display only the first document */}
                                                                                                    {TickeREtrievdatas?.documents[0] && (
                                                                                                        <span className="attachments-list">
                                                                                                            <span className="document-info">
                                                                                                                <img className="gallery-img" src={galleryimg2} alt="Gallery" />
                                                                                                                {TickeREtrievdatas.documents[0].split('/').pop()}
                                                                                                                {/* Document.{TickeREtrievdatas?.documents[0]?.split('.').pop()}  */}
                                                                                                            </span>
                                                                                                            <span
                                                                                                                className="download-options"
                                                                                                                onClick={() => window.open(TickeREtrievdatas?.documents[0], '_blank')}
                                                                                                            >
                                                                                                                <img src={downloadimg2} alt="Download" />
                                                                                                            </span>
                                                                                                        </span>
                                                                                                    )}


                                                                                                    {TickeREtrievdatas?.documents[1] && (
                                                                                                        <span className="attachments-list">
                                                                                                            <span className="document-info">
                                                                                                                <img className="gallery-img" src={galleryimg2} alt="Gallery" />
                                                                                                                {TickeREtrievdatas.documents[1].split('/').pop()}                                                                                                                {/* Document.{TickeREtrievdatas?.documents[1]?.split('.').pop()} */}
                                                                                                            </span>
                                                                                                            <span
                                                                                                                className="download-options"
                                                                                                                onClick={() => window.open(TickeREtrievdatas?.documents[1], '_blank')}
                                                                                                            >
                                                                                                                <img src={downloadimg2} alt="Download" />
                                                                                                            </span>
                                                                                                        </span>
                                                                                                    )}
                                                                                                </div>

                                                                                                {/* Show "+X" if there are more documents */}
                                                                                                {TickeREtrievdatas?.documents.length > 2 && (
                                                                                                    <div className="more-documents"

                                                                                                        onClick={() => setModalOpen(true)}
                                                                                                    >
                                                                                                        +{TickeREtrievdatas?.documents.length - 2} more
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        )}


                                                                                        {/* <p className='FileAttachments'> */}

                                                                                        {/* {TickeREtrievdatas?.documents == undefined || TickeREtrievdatas?.documents == null ||
                                                                                TickeREtrievdatas?.documents.length == 0 ? "" :

                                                                                <>{
                                                                                    TickeREtrievdatas?.documents.map((item) => {
                                                                                        const fileExtension = item?.split('.').pop(); // Get the extension from the URL


                                                                                        return (
                                                                                            <>

                                                                                                <span className="Attachmentslist">
                                                                                                    <span>
                                                                                                        <img className='galleryimg' src={galleryimg2} />
                                                                                                        Document.{fileExtension}

                                                                                                    </span>

                                                                                                    <span className='Downloadimgoptions' onClick={() => {
                                                                                                        window.open(item)
                                                                                                    }}>
                                                                                                        <img src={downloadimg2} />

                                                                                                    </span>
                                                                                                </span>

                                                                                            </>



                                                                                        )

                                                                                    })
                                                                                }

                                                                                </>

                                                                            } */}


                                                                                        {/* <>
                                                                            {TickeREtrievdatas?.documents?.map(
                                                                                (slot, userIndex) => {
                                                                                    if (userIndex <= 2) {
                                                                                        return (
                                                                                            <div
                                                                                                key={userIndex}
                                                                                                className="user-profile-item"
                                                                                            >
                                                                                                {slot !=
                                                                                                    null ? (


                                                                                                    <p
                                                                                                        className="assign-profile"
                                                                                                        onClick={() => {
                                                                                                            window.open(slot)
                                                                                                        }}
                                                                                                        style={{
                                                                                                            zIndex:
                                                                                                                userIndex +
                                                                                                                1,
                                                                                                            marginLeft:
                                                                                                                userIndex !=
                                                                                                                    0
                                                                                                                    ? "-15px"
                                                                                                                    : "",
                                                                                                            border:
                                                                                                                slot.status ==
                                                                                                                    "0"
                                                                                                                    ? " 1px solid #7ed957"
                                                                                                                    : slot.status ==
                                                                                                                        "1"
                                                                                                                        ? " 1px solid gray"
                                                                                                                        : " 1px solid gray",
                                                                                                            color: slot.status == 0 ?
                                                                                                                "white" :
                                                                                                                "gray"

                                                                                                        }}>

                                                                                                        <img src={slot} />
                                                                                                    </p>
                                                                                                ) : (


                                                                                                    <p

                                                                                                        className="noimg"

                                                                                                        style={{
                                                                                                            zIndex:
                                                                                                                userIndex +
                                                                                                                1,
                                                                                                            marginLeft:
                                                                                                                userIndex !=
                                                                                                                    0
                                                                                                                    ? "-15px"
                                                                                                                    : "",
                                                                                                            border:
                                                                                                                "1px solid gray",
                                                                                                            color: "white",
                                                                                                        }}>

                                                                                                        <img src={slot} />

                                                                                                    </p>

                                                                                                )}
                                                                                            </div>
                                                                                        );
                                                                                    } else if (
                                                                                        userIndex === 3
                                                                                    ) {
                                                                                        return (
                                                                                            <p
                                                                                                key={userIndex}
                                                                                                className="user-profile-item user-profile-item1"
                                                                                                style={{
                                                                                                    border:
                                                                                                        slot.status ==
                                                                                                            "0"
                                                                                                            ? " 1px solid #7ed957"
                                                                                                            : slot.status ==
                                                                                                                "1"
                                                                                                                ? " 1px solid gray"
                                                                                                                : " 1px solid gray",
                                                                                                    color: slot.status == 0 ?
                                                                                                        "white" :
                                                                                                        "gray"
                                                                                                }}


                                                                                            >
                                                                                                +
                                                                                                {TickeREtrievdatas?.documents
                                                                                                    .length - 3}
                                                                                            </p>
                                                                                        );
                                                                                    }
                                                                                    return null; // Skip remaining users
                                                                                }
                                                                            )}



                                                                        </> */}

                                                                                        {/* </p> */}


                                                                                    </p>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div>

                                                                    <p className='TicketRemarksTviews'>

                                                                        <span className="ticketheader ticketheadercards">Remarks</span>

                                                                        <div className='ticket-activity'>
                                                                            <div className='Ticketviewexpands'>
                                                                                {/* {state.commentsDatas.CommentsDatas.length > 0 && (  */}
                                                                                <div className={`timeline ${TickeREtrievdatas?.status == 3 ? "timelinewidthchanges" : ""}`}
                                                                                    ref={timelineRefremarks}
                                                                                >
                                                                                    {state.commentsDatas.CommentsDatas != undefined && state.commentsDatas.CommentsDatas.length > 0 ?
                                                                                        <>
                                                                                            {state.commentsDatas.CommentsDatas != undefined &&
                                                                                                state.commentsDatas.CommentsDatas.length > 0 && state.commentsDatas.CommentsDatas.map((item, index) => {
                                                                                                    const firstName = item.qpms_user_id?.first_name ? item.qpms_user_id?.first_name.toUpperCase() : "";
                                                                                                    const formattedName = firstName ? `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}` : "N/A";

                                                                                                    return (
                                                                                                        <>

                                                                                                            <div className="timeline-item"
                                                                                                                // ref={Remarkesref}
                                                                                                                ref={Remarkesref}
                                                                                                            >
                                                                                                                <div className="timeline-icon TimeLinePersongIMGS">
                                                                                                                    <span>
                                                                                                                        {/* {state.SideBarFiles.LoginIDs == item.qpms_user_id?.id ? "You" :
                                                                                                                                item.qpms_user_id?.first_name ? { formattedName } :

                                                                                                                                    item.client_user_id?.first_name ?
                                                                                                                                        { formattedName } :
                                                                                                                                        "Not mention"}
                                                                                                                                         */}
                                                                                                                        {item.qpms_user_id?.first_name ? formattedName : item.client_user_id?.first_name ? formattedName : "Not mention"}
                                                                                                                    </span>

                                                                                                                    {/* <img src={ticketactiveimgs} className='personImg' alt="" /> */}
                                                                                                                    {/* <img src={profile2} alt="User" className='personImg' /> */}
                                                                                                                </div>

                                                                                                                {state.commentsDatas?.CommentsDatas?.length &&
                                                                                                                    index + 1 !== state.commentsDatas.CommentsDatas.length && (
                                                                                                                        <div className='Lineofnext'></div>
                                                                                                                    )
                                                                                                                }
                                                                                                                <div className="timeline-content">
                                                                                                                    <div className='EscalationPersondetails'>
                                                                                                                        {item.name ? <p className="message">


                                                                                                                            <p className="user-name">
                                                                                                                                <span>
                                                                                                                                    {state.SideBarFiles.LoginIDs == item.qpms_user_id?.id ? "You" :
                                                                                                                                        item.qpms_user_id?.first_name ? capitalizeFirstLetter(item.qpms_user_id?.first_name) :

                                                                                                                                            item.client_user_id?.first_name ?
                                                                                                                                                capitalizeFirstLetter(item.client_user_id?.first_name) :
                                                                                                                                                "Not mention"}



                                                                                                                                    {(state.SideBarFiles.LoginIDs !== item.qpms_user_id?.id && item.client_user_id?.first_name) ||
                                                                                                                                        item.qpms_user_id?.first_name ? (
                                                                                                                                        <>
                                                                                                                                            {state.SideBarFiles.LoginIDs !== item.qpms_user_id?.id ? (
                                                                                                                                                <button className='MentiontheUSer'>
                                                                                                                                                    {state.SideBarFiles.LoginIDs === item.qpms_user_id?.id
                                                                                                                                                        ? ""
                                                                                                                                                        : item.qpms_user_id?.first_name
                                                                                                                                                            ? "QPMS"
                                                                                                                                                            : item.client_user_id?.first_name
                                                                                                                                                                ? "CLIENT"
                                                                                                                                                                : ""}
                                                                                                                                                </button>
                                                                                                                                            ) : null}
                                                                                                                                        </>
                                                                                                                                    ) : null}


                                                                                                                                </span>


                                                                                                                                <span className="timestamp">{item.created_at ? formatedDateList(item.created_at) : ""}</span>


                                                                                                                            </p>

                                                                                                                            {item.name ? capitalizeFirstLetter(item.name) : ""}
                                                                                                                        </p>
                                                                                                                            : null}



                                                                                                                    </div>
                                                                                                                    <>

                                                                                                                        {/* 
                                                                                                                        {item.documents !== undefined && item.documents !== null && item.documents.length > 0 ? (
                                                                                                                            <div className="attachment">
                                                                                                                                <img src={galleyimg} alt="Attachment" />
                                                                                                                                <span>{item.documents.length} File Attached</span>

                                                                                                                                {item.documents.map((document, index) => (
                                                                                                                                    <button
                                                                                                                                        key={index}
                                                                                                                                        className="download-btn"
                                                                                                                                        onClick={() => downloadAll(item.documents)}

                                                                                                                                    >
                                                                                                                                        <img src={downloadimg} alt="Download" />
                                                                                                                                    </button>
                                                                                                                                ))}
                                                                                                                            </div>
                                                                                                                        ) : null} */}




                                                                                                                        {Array.isArray(item.documents) && item.documents.length > 0 ? (
                                                                                                                            <div className="attachment">
                                                                                                                                <img src={galleyimg} alt="Attachment" />
                                                                                                                                <span>{item.documents.length} File Attached</span>

                                                                                                                                {item.documents.map((document, index) => (
                                                                                                                                    <button
                                                                                                                                        key={index}
                                                                                                                                        className="download-btn"
                                                                                                                                        onClick={() => downloadAll(item.documents)}
                                                                                                                                    >
                                                                                                                                        <img src={downloadimg} alt="Download" />
                                                                                                                                    </button>
                                                                                                                                ))}
                                                                                                                            </div>
                                                                                                                        ) : null}


                                                                                                                    </>

                                                                                                                </div>
                                                                                                            </div>





                                                                                                        </>
                                                                                                    )
                                                                                                })}

                                                                                        </>
                                                                                        :
                                                                                        <><div className='CommunicationAlters'>
                                                                                            <p>
                                                                                                Add Important Remarks or Documents that ae need to be known for
                                                                                                <br />
                                                                                                successful ticket resolution
                                                                                            </p>
                                                                                        </div>
                                                                                        </>
                                                                                    }
                                                                                </div>
                                                                                {/* )} */}

                                                                                {TickeREtrievdatas?.status == 3 ? null :
                                                                                    <div className="message-input">
                                                                                        <form onSubmit={HandleSubmit}>


                                                                                            <label className='Droplabel'
                                                                                                htmlFor="fileUploadInput"
                                                                                                style={{ paddingTop: "6px", cursor: "pointer" }}
                                                                                                onClick={() => { setActiveonUploads(1) }}
                                                                                            >
                                                                                                <img src={Uploadimg} />
                                                                                            </label>
                                                                                            <input
                                                                                                id="fileUploadInput"
                                                                                                type="file"
                                                                                                style={{ display: "none" }}
                                                                                                onChange={handleFileChange}
                                                                                                multiple
                                                                                            />
                                                                                            <div style={{
                                                                                                display: "flex",
                                                                                                flexDirection: "row",
                                                                                                padding: "3px 3px"
                                                                                            }}>

                                                                                                <div className={`${ActiveofUploads == 1 && Remarskspopuo == false && PresentUrls.length > 0 ? "Innerholadimages" : ""}`}>
                                                                                                    {Remarskspopuo == false &&
                                                                                                        ActiveofUploads == 1 &&
                                                                                                        PresentUrls.map((file, index) => {
                                                                                                            // console.log(file, "asdpuasod file");

                                                                                                            let displayImg;
                                                                                                            if (file.type === "image/png" || file.type === "image/jpeg") {
                                                                                                                displayImg = galleyimg; // Replace with your gallery image variable
                                                                                                            } else if (file.type === "application/pdf") {
                                                                                                                displayImg = PDFIMAGE; // Replace with your PDF icon variable
                                                                                                            } else if (file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                                                                                                                displayImg = excelimg; // Replace with your Excel icon variable
                                                                                                            } else {
                                                                                                                displayImg = gallimages; // Replace with a default image/icon if none match
                                                                                                            }
                                                                                                            return (
                                                                                                                <>

                                                                                                                    <div key={index} style={{
                                                                                                                        position: "relative",
                                                                                                                        width: "38px",
                                                                                                                        height: "38px",
                                                                                                                        borderRadius: "8px",
                                                                                                                    }}>
                                                                                                                        <img
                                                                                                                            src={displayImg}
                                                                                                                            alt={`Uploaded File ${index + 1}`}
                                                                                                                            style={{
                                                                                                                                width: "100%",
                                                                                                                                height: "100%",
                                                                                                                                objectFit: "cover",
                                                                                                                                borderRadius: "8px",
                                                                                                                                border: "1px solid #ddd",
                                                                                                                            }}
                                                                                                                        />
                                                                                                                        <button
                                                                                                                            type="button"
                                                                                                                            className=" btn-danger btn-sm CloseImagesSend"
                                                                                                                            style={{

                                                                                                                                marginRight: "1px",

                                                                                                                            }}

                                                                                                                            onClick={() => removeFile(index)}
                                                                                                                        >
                                                                                                                            &times;
                                                                                                                        </button>
                                                                                                                    </div>
                                                                                                                </>
                                                                                                            )
                                                                                                        })}

                                                                                                </div>

                                                                                                {/* <div className='Containsthebothfields'> */}
                                                                                                <div className={`Containsthebothfields ${ActiveofUploads != 2 && Remarskspopuo == false && PresentUrls.length > 0 ? "increasethetops" : ""}`}>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className="form-control"
                                                                                                        placeholder="Type your message here..."
                                                                                                        onChange={(e) => {
                                                                                                            if (Remarskspopuo == false) {
                                                                                                                HandleChangescomments(e)

                                                                                                            }
                                                                                                        }}
                                                                                                        value={Remarskspopuo == false ? comment.name : ""}
                                                                                                        name="name"
                                                                                                    />


                                                                                                    <button className="send-btn"
                                                                                                        type='Submit'

                                                                                                        onClick={() => {
                                                                                                            HandleRemarsks("3") /// This is for the remarks
                                                                                                        }}
                                                                                                    >
                                                                                                        <img src={sendimg} />

                                                                                                    </button>
                                                                                                </div>

                                                                                            </div>




                                                                                        </form>

                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                    </p>
                                                                </div>
                                                                {/* // } */}
                                                                {/* <p className="mb-1 cardpara">
                                                                    <span className='ticketheader ticketheadercards '>Assignee</span>
                                                                    <p className='FileAttachments'>
                                                                        {TickeREtrievdatas?.client_id != undefined &&
                                                                            TickeREtrievdatas?.client_id != null &&
                                                                            TickeREtrievdatas?.client_id?.l1_user.map((item) => {

                                                                                return (
                                                                                    <span className="Attachmentslist">
                                                                                        {`${capitalizeEachWord(item.first_name.toLowerCase())} ${capitalizeEachWord(item.last_name.toLowerCase())}`}
                                                                                    </span>
                                                                                )
                                                                            })}
                                                                    </p>
                                                                </p> */}
                                                            </div>
                                                        </div>




                                                    </div>







                                                </div>

                                                <div className="col-5 PartTwoOFTicketDetails">
                                                    <div className='Innerticketview5'>
                                                        <div className="  EScalationlevel  mb-4">
                                                            <div className="card  p-3" >
                                                                <div className='HeaderTimelines HeaderOFEscalationlevel'>

                                                                    <div className='HeaderHeadings'>
                                                                        <h5>Escalation Level</h5>
                                                                        {StoretheEscalate != "" ?

                                                                            <>
                                                                                {StoretheEscalate == "assign" ?

                                                                                    <>

                                                                                        <div className='AssignsBtnviews'>
                                                                                            {/* <button
                                                                                onClick={(e) => { HanldtheRejectTickets() }}>Reject</button> */}
                                                                                            {StoretheEscalate != "" ?


                                                                                                <>
                                                                                                    {StoretheEscalate == "assign" ?
                                                                                                        <>
                                                                                                            {TickeREtrievdatas?.status == 0 || TickeREtrievdatas?.status == 1 ?
                                                                                                                <button
                                                                                                                    onClick={() => {
                                                                                                                        HandleTheAssings()
                                                                                                                    }}
                                                                                                                     className=' Sub_Assign_btn'
                                                                                                                > Sub Assign</button>
                                                                                                                :
                                                                                                                null}
                                                                                                        </>
                                                                                                        :

                                                                                                        <>

                                                                                                            {StoretheEscalate == "view" ?
                                                                                                                <>
                                                                                                                    {/* {TickeREtrievdatas?.status == 0 || TickeREtrievdatas?.status == 1 ? */}
                                                                                                                    <button
                                                                                                                        onClick={() => {
                                                                                                                            HandleTheViewsof()
                                                                                                                        }}
                                                                                                                    >View</button>
                                                                                                                    :
                                                                                                                    {/* null} */}
                                                                                                                </>
                                                                                                                : null}

                                                                                                        </>

                                                                                                    }
                                                                                                </>
                                                                                                :
                                                                                                <>
                                                                                                </>

                                                                                            }




                                                                                        </div>

                                                                                    </>
                                                                                    :

                                                                                    <>
                                                                                        <div className='AssignsBtnviews'>
                                                                                            {/* {TickeREtrievdatas?.status == 0 || TickeREtrievdatas?.status == 1 ? */}

                                                                                            <button
                                                                                                className='externalTicketViews'
                                                                                                onClick={(e) => {
                                                                                                    HandleTheViewsof()

                                                                                                }}
                                                                                            >
                                                                                                <p className='ImgHoldTicketnumbers'>
                                                                                                    {/* <img src={linkthetickets} /> */}
                                                                                                  <span className='TicketTitles'>  {"Sub Ticket"}</span>
                                                                                                    <span className='ticketNumbersview'>{`I-${state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.ticket_number}`}</span>
                                                                                                </p>
                                                                                                <p>

                                                                                                    <span
                                                                                                        style={{
                                                                                                            background: state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 0 ? "#FDEDE9" : // Open - light background
                                                                                                                state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 1 ? "#FFF8E5" : // In Progress - yellow background
                                                                                                                    state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 2 ? "#E7F8ED" : // Completed - light green background
                                                                                                                        state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 3 ? "#DFFFE3" : // Close - light green background for Close
                                                                                                                            "#FFDDDD", // Default for Reopen - light red background
                                                                                                            color: state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 0 ? "#234492" : // Open - red text
                                                                                                                state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 1 ? "#FFB800" : // In Progress - yellow text
                                                                                                                    state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 2 ? "#12B749" : // Completed - green text
                                                                                                                        state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 3 ? "#8BC34A" : // Close - light green text for Close
                                                                                                                            state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 4 || state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 5 && "#234492", // Default for Reopen - red text
                                                                                                            padding: "5px 8px",
                                                                                                            // margin:"7px",
                                                                                                            fontSize: "13px",
                                                                                                            display: "block",
                                                                                                            width:"98px"
                                                                                                            // display:"contents"
                                                                                                        }}



                                                                                                    >

                                                                                                        {state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 0 ? "Open" :
                                                                                                            state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 1 ? "In Progress" :
                                                                                                                state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 2 ? "Review" :
                                                                                                                    state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 3 ? "Resolved" :
                                                                                                                        state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 4 ?
                                                                                                                            "Reopened"

                                                                                                                            : state?.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer[0]?.status == 5 && "Rejected"}
                                                                                                    </span>
                                                                                                </p>
                                                                                            </button>
                                                                                            {/* // : null} */}
                                                                                        </div>
                                                                                    </>
                                                                                }


                                                                            </>
                                                                            :
                                                                            <>
                                                                            </>
                                                                        }                                                                  </div>


                                                                </div>


                                                                <>
                                                                    {Escalationpopup && (
                                                                        <div className='ProgressInoverall'>


                                                                            <div className={`${StoretheEscalate != "view" > 0 ? "Internalticketserializers" : "Internalticketserializersnot"}`}>
                                                                             
                                                                                {
                                                                                    state.ticketexcalationrecordoflist?.ticketescalationdatas &&
                                                                                        state.ticketexcalationrecordoflist.ticketescalationdatas != undefined &&
                                                                                        state.ticketexcalationrecordoflist.ticketescalationdatas != null &&
                                                                                        state.ticketexcalationrecordoflist.ticketescalationdatas.length > 0 &&
                                                                                        state.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer?.length > 0 ?

                                                                                        <div className='departmentNames' >
                                                                                            <p>{"Ops"}</p>
                                                                                        </div>
                                                                                        : null}

                                                                                <div className="progress-TIMELINE" style={{ borderTop: "1px solid #D9D9D9", borderRight: StoretheEscalate == "view" ? "1px solid #D9D9D9" : "" }}>
                                                                                    <div className='InnerMattersLEVEL'>
                                                                                        <div className='Levelofpersons'>
                                                                                            <div className={`timeline-icon ${TickeREtrievdatas?.overdue_stage == "l1" ? "TimeLinePersongIMGS" :
                                                                                                TickeREtrievdatas?.overdue_stage == "l2" ?
                                                                                                    "TimeLinePersongIMGS" : TickeREtrievdatas?.overdue_stage == "l3" ?
                                                                                                        "TimeLinePersongIMGS" : "TimeLinePersongNON"}`}>
                                                                                                L1
                                                                                            </div>
                                                                                            <div class="timeline-line"></div>
                                                                                        </div>


                                                                                        <div className='Holdtheusers'>


                                                                                            {TickeREtrievdatas?.l1_users &&
                                                                                                TickeREtrievdatas.l1_users.map((item, index) => {
                                                                                                    const firstName = item.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                    const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                    return (
                                                                                                        <div className='PersonsNamesHeaders'>
                                                                                                            <span
                                                                                                                key={index}
                                                                                                                className="PersonsNames"
                                                                                                                onMouseEnter={() => setShowTooltip(index)}
                                                                                                                onMouseLeave={() => setShowTooltip(null)}
                                                                                                            >
                                                                                                                {formattedName}
                                                                                                                {showTooltip === index && (
                                                                                                                    <div className="custom-tooltip">
                                                                                                                        <span>{item.first_name || 'No Role Available'}</span>
                                                                                                                    </div>
                                                                                                                )}
                                                                                                            </span>

                                                                                                            {TickeREtrievdatas.l1_users.length == 1 ?
                                                                                                                <p className='FirstNameCapitals'>{item.first_name && capitalizeEachWord(item.first_name)}</p>
                                                                                                                : null}
                                                                                                        </div>
                                                                                                    );
                                                                                                })}


                                                                                        </div>
                                                                                    </div>

                                                                                    <div className='InnerMattersLEVEL'>

                                                                                        <div className='Levelofpersons'>
                                                                                            <div className={`timeline-icon ${TickeREtrievdatas?.overdue_stage == "l2" ?
                                                                                                "TimeLinePersongIMGS" : TickeREtrievdatas?.overdue_stage == "l3" ?
                                                                                                    "TimeLinePersongIMGS" : "TimeLinePersongNON"}`}>
                                                                                                L2
                                                                                            </div>
                                                                                            <div class="timeline-line"></div>
                                                                                        </div>
                                                                                        <div className='InnerPersonslist'>

                                                                                            {/* {TickeREtrievdatas?.l2_users != undefined &&
                                                                                    TickeREtrievdatas?.l2_users != null &&
                                                                                    TickeREtrievdatas?.l2_users.map((item) => {
                                                                                        const firstName = item.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                        const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter
                                                                                        return (
                                                                                            <span className="PersonsName2">{formattedName}</span>
                                                                                        );
                                                                                    })} */}

                                                                                            <div className='Holdtheusers'>

                                                                                                {TickeREtrievdatas?.l2_users &&
                                                                                                    TickeREtrievdatas.l2_users.map((item, index) => {
                                                                                                        const firstName = item.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                        const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                        return (
                                                                                                            <div className='PersonsNamesHeaders'>

                                                                                                                <span
                                                                                                                    key={index}
                                                                                                                    className="PersonsNames PersonsNames3"
                                                                                                                    onMouseEnter={() => setShowTooltipone(index)}
                                                                                                                    onMouseLeave={() => setShowTooltipone(null)}


                                                                                                                >
                                                                                                                    {formattedName}
                                                                                                                    {showTooltipone === index && (
                                                                                                                        <div className="custom-tooltip">
                                                                                                                            <span>  {item.first_name || 'No Role Available'}</span>
                                                                                                                        </div>
                                                                                                                    )}


                                                                                                                </span>
                                                                                                                {TickeREtrievdatas.l2_users.length == 1 ?

                                                                                                                    <p className='FirstNameCapitals'>{item.first_name && capitalizeEachWord(item.first_name)}</p>
                                                                                                                    : null}
                                                                                                            </div>
                                                                                                        );
                                                                                                    })}
                                                                                            </div>

                                                                                        </div>


                                                                                    </div>


                                                                                    <div className='InnerMattersLEVEL'>
                                                                                        <div className='Levelofpersons'>
                                                                                            <div className={`timeline-icon ${TickeREtrievdatas?.overdue_stage == "l3" ? "TimeLinePersongIMGS" :
                                                                                                "TimeLinePersongNON"}`}>
                                                                                                L3
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className='Holdtheusers'>
                                                                                            {/* {TickeREtrievdatas?.l3_users != undefined &&
                                                                                    TickeREtrievdatas?.l3_users != null &&
                                                                                    TickeREtrievdatas?.l3_users.map((item) => {
                                                                                        const firstName = item.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                        const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter
                                                                                        return (    
                                                                                            <span className="PersonsName2">{formattedName}</span>
                                                                                        );
                                                                                    })} */}

                                                                                            {TickeREtrievdatas?.l3_users &&
                                                                                                TickeREtrievdatas.l3_users.map((item, index) => {
                                                                                                    const firstName = item.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                    const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                    return (
                                                                                                        <div className='PersonsNamesHeaders'>

                                                                                                            <span
                                                                                                                key={index}
                                                                                                                className="PersonsNames PersonsNames4"
                                                                                                                onMouseEnter={() => setShowTooltiptwo(index)}
                                                                                                                onMouseLeave={() => setShowTooltiptwo(null)}


                                                                                                            >
                                                                                                                {formattedName}
                                                                                                                {showTooltiptwo === index && (
                                                                                                                    <div className="custom-tooltip">
                                                                                                                        <span>  {capitalizeEachWord(item.first_name) || 'No Role Available'}</span>
                                                                                                                    </div>
                                                                                                                )}
                                                                                                            </span>
                                                                                                            {TickeREtrievdatas.l3_users.length == 1 ?

                                                                                                                <p className='FirstNameCapitals'


                                                                                                                >{item.first_name && capitalizeEachWord(item.first_name)}</p>
                                                                                                                : null}
                                                                                                        </div>
                                                                                                    );
                                                                                                })}



                                                                                        </div>
                                                                                    </div>



                                                                                </div>

                                                                            </div>

                                                                            {state.ticketexcalationrecordoflist?.ticketescalationdatas &&
                                                                                state.ticketexcalationrecordoflist.ticketescalationdatas != undefined &&
                                                                                state.ticketexcalationrecordoflist.ticketescalationdatas.length > 0 &&
                                                                                state.ticketexcalationrecordoflist.ticketescalationdatas.map((escalations) => {
                                                                                    console.log(escalations.internal_ticket_serializer, escalations.internal_ticket_serializer.length, "sdpfosdoifospdfiopsdf spodif ",
                                                                                        state.ticketexcalationrecordoflist?.ticketescalationdatas,

                                                                                        state.ticketexcalationrecordoflist?.ticketescalationdatas &&
                                                                                        state.ticketexcalationrecordoflist.ticketescalationdatas != undefined &&
                                                                                        state.ticketexcalationrecordoflist.ticketescalationdatas != null &&
                                                                                        state.ticketexcalationrecordoflist.ticketescalationdatas.length > 0 &&
                                                                                        state.ticketexcalationrecordoflist?.ticketescalationdatas[0]?.internal_ticket_serializer?.length
                                                                                    );

                                                                                    return (
                                                                                        <>
                                                                                            {escalations &&
                                                                                                escalations.internal_ticket_serializer != undefined &&
                                                                                                escalations.internal_ticket_serializer.length > 0 &&
                                                                                                // escalations.internal_ticket_serializer.map((item, index, array) => {
                                                                                                //     return (
                                                                                                <>
                                                                                                    <div className={`${escalations.internal_ticket_serializer.length > 1 ? "Internalticketserializers" : "Internalticketserializersnot"}`}>
                                                                                                        <div className='departmentNames'>
                                                                                                            <p>{`${escalations.internal_ticket_serializer[0]?.department_id?.department_name}`}</p>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className={`progress-TIMELINE innerescalationlisted `}
                                                                                                        >
                                                                                                            <div className='InnerMattersLEVEL'>
                                                                                                                <div className='Levelofpersons'>
                                                                                                                    {escalations.internal_ticket_serializer[0]?.l1_users != undefined && escalations.internal_ticket_serializer[0]?.l1_users != null && escalations.internal_ticket_serializer[0]?.l1_users.length > 0 ?
                                                                                                                        <>
                                                                                                                            <div className={`timeline-icon ${escalations.internal_ticket_serializer[0]?.overdue_stage == "l1" ? "TimeLinePersongIMGS" :
                                                                                                                                escalations.internal_ticket_serializer[0]?.overdue_stage == "l2" ?
                                                                                                                                    "TimeLinePersongIMGS" : escalations.internal_ticket_serializer[0]?.overdue_stage == "l3" ?
                                                                                                                                        "TimeLinePersongIMGS" : "TimeLinePersongNON"}`}>
                                                                                                                                L1
                                                                                                                            </div>
                                                                                                                            <div class="timeline-line"></div>
                                                                                                                        </>
                                                                                                                        : null}
                                                                                                                </div>


                                                                                                                <div className='Holdtheusers'>


                                                                                                                    {escalations.internal_ticket_serializer[0]?.l1_users != undefined && escalations.internal_ticket_serializer[0]?.l1_users.length > 0 &&
                                                                                                                        escalations.internal_ticket_serializer[0].l1_users.map((itemone, indexone) => {
                                                                                                                            const firstName = itemone.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                            const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter
                                                                                                                            console.log(itemone.first_name, itemone, "asodkapskdpasd itemone asodkapskdpasd itemone", firstName, formattedName);

                                                                                                                            return (
                                                                                                                                <div className='PersonsNamesHeaders'>
                                                                                                                                    <span
                                                                                                                                        key={indexone}
                                                                                                                                        className="PersonsNames"
                                                                                                                                    >
                                                                                                                                        {formattedName}

                                                                                                                                    </span>

                                                                                                                                    {itemone.first_name != undefined && itemone.first_name != null && itemone.first_name ?
                                                                                                                                        <p className='FirstNameCapitals'>{itemone.first_name != null && itemone.first_name && capitalizeEachWord(itemone.first_name)}</p>
                                                                                                                                        : null}
                                                                                                                                </div>

                                                                                                                            );
                                                                                                                        })}


                                                                                                                </div>
                                                                                                            </div>

                                                                                                            <div className='InnerMattersLEVEL'>

                                                                                                                <div className='Levelofpersons'>
                                                                                                                    {escalations.internal_ticket_serializer[0]?.l2_users != undefined && escalations.internal_ticket_serializer[0]?.l2_users != null && escalations.internal_ticket_serializer[0]?.l2_users.length > 0 ?

                                                                                                                        <>

                                                                                                                            <div className={`timeline-icon ${escalations.internal_ticket_serializer[0]?.overdue_stage == "l2" ?
                                                                                                                                "TimeLinePersongIMGS" : escalations.internal_ticket_serializer[0]?.overdue_stage == "l3" ?
                                                                                                                                    "TimeLinePersongIMGS" : "TimeLinePersongNON"}`}>
                                                                                                                                L2
                                                                                                                            </div>
                                                                                                                            <div class="timeline-line"></div>
                                                                                                                        </>
                                                                                                                        : null}

                                                                                                                </div>
                                                                                                                <div className='InnerPersonslist'>

                                                                                                                    <div className='Holdtheusers'>

                                                                                                                        {escalations.internal_ticket_serializer[0]?.l2_users != undefined && escalations.internal_ticket_serializer[0]?.l2_users != null && escalations.internal_ticket_serializer[0]?.l2_users &&
                                                                                                                            escalations.internal_ticket_serializer[0].l2_users.map((itemUsertwo, indextwousers) => {
                                                                                                                                const firstName = itemUsertwo.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                                const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                                                return (
                                                                                                                                    <div className='PersonsNamesHeaders'>

                                                                                                                                        <span
                                                                                                                                            key={indextwousers}
                                                                                                                                            className="PersonsNames PersonsNames3"

                                                                                                                                        >
                                                                                                                                            {formattedName}

                                                                                                                                        </span>
                                                                                                                                        {itemUsertwo.first_name != undefined && itemUsertwo.first_name != null && itemUsertwo.first_name ?
                                                                                                                                            <p className='FirstNameCapitals'>{itemUsertwo.first_name && capitalizeEachWord(itemUsertwo.first_name)}</p>
                                                                                                                                            : null}
                                                                                                                                    </div>
                                                                                                                                );
                                                                                                                            })}
                                                                                                                    </div>

                                                                                                                </div>


                                                                                                            </div>


                                                                                                            <div className='InnerMattersLEVEL'>
                                                                                                                <div className='Levelofpersons'>
                                                                                                                    {escalations.internal_ticket_serializer[0]?.l3_users != undefined && escalations.internal_ticket_serializer[0]?.l3_users != null && escalations.internal_ticket_serializer[0]?.l3_users.length > 0 ?
                                                                                                                        <>

                                                                                                                            <div className={`timeline-icon ${escalations.internal_ticket_serializer[0]?.overdue_stage == "l3" ? "TimeLinePersongIMGS" :
                                                                                                                                "TimeLinePersongNON"}`}>
                                                                                                                                L3
                                                                                                                            </div>
                                                                                                                        </>

                                                                                                                        : null}
                                                                                                                </div>

                                                                                                                <div className='Holdtheusers'>

                                                                                                                    {escalations.internal_ticket_serializer[0]?.l3_users &&
                                                                                                                        escalations.internal_ticket_serializer[0].l3_users.map((itemthree, indexthrid) => {
                                                                                                                            const firstName = itemthree.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                            const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                                            return (
                                                                                                                                <div className='PersonsNamesHeaders'>

                                                                                                                                    <span
                                                                                                                                        key={indexthrid}
                                                                                                                                        className="PersonsNames PersonsNames4"


                                                                                                                                    >
                                                                                                                                        {formattedName}

                                                                                                                                    </span>
                                                                                                                                    {itemthree.first_name != undefined && itemthree.first_name ?

                                                                                                                                        <p className='FirstNameCapitals'
                                                                                                                                        >{itemthree.first_name && capitalizeEachWord(itemthree.first_name)}</p>
                                                                                                                                        : null}
                                                                                                                                </div>
                                                                                                                            );
                                                                                                                        })}



                                                                                                                </div>
                                                                                                            </div>



                                                                                                        </div>

                                                                                                    </div >
                                                                                                </>
                                                                                                //     )
                                                                                                // })}
                                                                                            }

                                                                                        </>
                                                                                    )
                                                                                })}


                                                                        </div>
                                                                    )}
                                                                </>
                                                                {/* {StoretheEscalate == "view" ?
                                                                    <>
                                                                        {Escalationpopup && (
                                                                            <div className='ProgressInoverall'>
                                                                                {state.ticketexcalationrecordoflist?.ticketescalationdatas &&
                                                                                    state.ticketexcalationrecordoflist.ticketescalationdatas != undefined &&
                                                                                    state.ticketexcalationrecordoflist.ticketescalationdatas.length > 0 &&
                                                                                    state.ticketexcalationrecordoflist.ticketescalationdatas.map((escalations) => {

                                                                                        return (
                                                                                            <>
                                                                                                {escalations &&
                                                                                                    escalations.internal_ticket_serializer != undefined &&
                                                                                                    escalations.internal_ticket_serializer.length > 0 &&
                                                                                                    escalations.internal_ticket_serializer.map((item, index, array) => {
                                                                                                        return (
                                                                                                            <>
                                                                                                                <div className={`${escalations.internal_ticket_serializer.length > 0 ? "Internalticketserializers" : "Internalticketserializersnot"}`}>
                                                                                                                    <div className='departmentNames'>
                                                                                                                        <p>{capitalizeEachWord(item?.department_id?.department_name.toLowerCase())}</p>
                                                                                                                    </div>
                                                                                                                    <div
                                                                                                                        className={`progress-TIMELINE innerescalationlisted ${index !== array.length - 1 ? "border-right" : ""
                                                                                                                            }`}
                                                                                                                    >
                                                                                                                        <div className='InnerMattersLEVEL'>
                                                                                                                            <div className='Levelofpersons'>
                                                                                                                                {item?.l1_users != undefined && item?.l1_users != null && item?.l1_users.length > 0 ?
                                                                                                                                    <>
                                                                                                                                        <div className={`timeline-icon ${item?.overdue_stage == "l1" ? "TimeLinePersongIMGS" :
                                                                                                                                            item?.overdue_stage == "l2" ?
                                                                                                                                                "TimeLinePersongIMGS" : item?.overdue_stage == "l3" ?
                                                                                                                                                    "TimeLinePersongIMGS" : "TimeLinePersongNON"}`}>
                                                                                                                                            L1
                                                                                                                                        </div>
                                                                                                                                        <div class="timeline-line"></div>
                                                                                                                                    </>
                                                                                                                                    : null}
                                                                                                                            </div>


                                                                                                                            <div className='Holdtheusers'>


                                                                                                                                {item?.l1_users != undefined && item?.l1_users.length > 0 &&
                                                                                                                                    item.l1_users.map((itemone, indexone) => {
                                                                                                                                        const firstName = itemone.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                                        const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter
                                                                                                                                        console.log(itemone, "asodkapskdpasd itemone", firstName, formattedName);

                                                                                                                                        return (
                                                                                                                                            <div className='PersonsNamesHeaders'>
                                                                                                                                                <span
                                                                                                                                                    key={indexone}
                                                                                                                                                    className="PersonsNames"
                                                                                                                                                >
                                                                                                                                                    {formattedName}

                                                                                                                                                </span>

                                                                                                                                                {itemone.l1_users != undefined && itemone.l1_users != null && itemone.l1_users.length == 1 ?
                                                                                                                                                    <p className='FirstNameCapitals'>{itemone.first_name != null && itemone.first_name && capitalizeEachWord(itemone.first_name)}</p>
                                                                                                                                                    : null}
                                                                                                                                            </div>

                                                                                                                                        );
                                                                                                                                    })}


                                                                                                                            </div>
                                                                                                                        </div>

                                                                                                                        <div className='InnerMattersLEVEL'>

                                                                                                                            <div className='Levelofpersons'>
                                                                                                                                {item?.l2_users != undefined && item?.l2_users != null && item?.l2_users.length > 0 ?

                                                                                                                                    <>

                                                                                                                                        <div className={`timeline-icon ${item?.overdue_stage == "l2" ?
                                                                                                                                            "TimeLinePersongIMGS" : item?.overdue_stage == "l3" ?
                                                                                                                                                "TimeLinePersongIMGS" : "TimeLinePersongNON"}`}>
                                                                                                                                            L2
                                                                                                                                        </div>
                                                                                                                                        <div class="timeline-line"></div>
                                                                                                                                    </>
                                                                                                                                    : null}

                                                                                                                            </div>
                                                                                                                            <div className='InnerPersonslist'>

                                                                                                                                <div className='Holdtheusers'>

                                                                                                                                    {item?.l2_users != undefined && item?.l2_users != null && item?.l2_users &&
                                                                                                                                        item.l2_users.map((itemUsertwo, indextwousers) => {
                                                                                                                                            const firstName = itemUsertwo.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                                            const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                                                            return (
                                                                                                                                                <div className='PersonsNamesHeaders'>

                                                                                                                                                    <span
                                                                                                                                                        key={indextwousers}
                                                                                                                                                        className="PersonsNames PersonsNames3"

                                                                                                                                                    >
                                                                                                                                                        {formattedName}

                                                                                                                                                    </span>
                                                                                                                                                    {itemUsertwo.l2_users != undefined && itemUsertwo.l2_users != null && itemUsertwo.l2_users.length == 1 ?
                                                                                                                                                        <p className='FirstNameCapitals'>{itemUsertwo.first_name && capitalizeEachWord(itemUsertwo.first_name)}</p>
                                                                                                                                                        : null}
                                                                                                                                                </div>
                                                                                                                                            );
                                                                                                                                        })}
                                                                                                                                </div>

                                                                                                                            </div>


                                                                                                                        </div>


                                                                                                                        <div className='InnerMattersLEVEL'>
                                                                                                                            <div className='Levelofpersons'>
                                                                                                                                {item?.l3_users != undefined && item?.l3_users != null && item?.l3_users.length > 0 ?
                                                                                                                                    <>

                                                                                                                                        <div className={`timeline-icon ${item?.overdue_stage == "l3" ? "TimeLinePersongIMGS" :
                                                                                                                                            "TimeLinePersongNON"}`}>
                                                                                                                                            L3
                                                                                                                                        </div>
                                                                                                                                    </>

                                                                                                                                    : null}
                                                                                                                            </div>

                                                                                                                            <div className='Holdtheusers'>

                                                                                                                                {item?.l3_users &&
                                                                                                                                    item.l3_users.map((itemthree, indexthrid) => {
                                                                                                                                        const firstName = itemthree.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                                        const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                                                        return (
                                                                                                                                            <div className='PersonsNamesHeaders'>

                                                                                                                                                <span
                                                                                                                                                    key={indexthrid}
                                                                                                                                                    className="PersonsNames PersonsNames4"


                                                                                                                                                >
                                                                                                                                                    {formattedName}

                                                                                                                                                </span>
                                                                                                                                                {itemthree.l3_users != undefined && itemthree.l3_users.length == 1 ?

                                                                                                                                                    <p className='FirstNameCapitals'


                                                                                                                                                    >{itemthree.first_name && capitalizeEachWord(itemthree.first_name)}</p>
                                                                                                                                                    : null}
                                                                                                                                            </div>
                                                                                                                                        );
                                                                                                                                    })}



                                                                                                                            </div>
                                                                                                                        </div>



                                                                                                                    </div>

                                                                                                                </div >
                                                                                                            </>
                                                                                                        )
                                                                                                    })}

                                                                                            </>
                                                                                        )
                                                                                    })}


                                                                            </div>
                                                                        )}
                                                                    </>
                                                                    :
                                                                    null
                                                                } */}




                                                            </div>

                                                        </div>

                                                        <div className=" Recentcard2 ">

                                                            <div className="ticket-activity container">
                                                                {/* <h5 className="title">Ticket Activity</h5> */}

                                                                <div className='ToggleOFTicketActiveTicketView'>

                                                                    <ul className="nav nav-tabs" role="tablist">
                                                                        <li className="nav-item" role="presentation">
                                                                            <button

                                                                                className={`  nav-link  ${state.FormsIDList.ActiveTabs == 4 ? "active" : ""
                                                                                    }`}
                                                                                id="ex3-tab-4"
                                                                                data-bs-toggle="tab"
                                                                                href="#ex3-tabs-4"
                                                                                role="tab"
                                                                                aria-controls="ex3-tabs-1"
                                                                                aria-selected={state.FormsIDList.ActiveTabs == 4}
                                                                                onClick={() => {
                                                                                    dispatch(SetActiveTabs(4));

                                                                                }}
                                                                            >
                                                                                Ticket Journey
                                                                            </button>
                                                                        </li>


                                                                        <li className="nav-item" role="presentation">
                                                                            <button

                                                                                className={`  nav-link  ${state.FormsIDList.ActiveTabs == 1 ? "active" : ""
                                                                                    }`}
                                                                                id="ex3-tab-1"
                                                                                data-bs-toggle="tab"
                                                                                href="#ex3-tabs-1"
                                                                                role="tab"
                                                                                aria-controls="ex3-tabs-1"
                                                                                aria-selected={state.FormsIDList.ActiveTabs == 1}
                                                                                onClick={() => {
                                                                                    dispatch(SetActiveTabs(1));

                                                                                }}
                                                                            >
                                                                                Chat
                                                                            </button>
                                                                        </li>


                                                                        {/* <li className="nav-item" role="presentation">

                                                                            <button
                                                                                className={`   nav-link  ${state.FormsIDList.ActiveTabs == 3 ? "active" : ""
                                                                                    }`}
                                                                                id="ex3-tab-3"
                                                                                data-bs-toggle="tab"
                                                                                href="#ex3-tabs-3"
                                                                                role="tab"
                                                                                aria-controls="ex3-tabs-3"
                                                                                aria-selected={state.FormsIDList.ActiveTabs == 3}
                                                                                onClick={() => {
                                                                                    dispatch(SetActiveTabs(3));

                                                                                }}
                                                                            >Remarks</button>
                                                                        </li> */}


                                                                        {state.ticketFeedbacklistedslice.feedbackrecords != undefined && state.ticketFeedbacklistedslice.feedbackrecords.length > 0 ?


                                                                            <li className="nav-item" role="presentation">

                                                                                <button
                                                                                    className={`   nav-link  ${state.FormsIDList.ActiveTabs == 2 ? "active" : ""
                                                                                        }`}
                                                                                    id="ex3-tab-2"
                                                                                    data-bs-toggle="tab"
                                                                                    href="#ex3-tabs-2"
                                                                                    role="tab"
                                                                                    aria-controls="ex3-tabs-2"
                                                                                    aria-selected={state.FormsIDList.ActiveTabs == 2}
                                                                                    onClick={() => {
                                                                                        dispatch(SetActiveTabs(2));

                                                                                    }}
                                                                                >Client Feedback</button>
                                                                            </li>
                                                                            : null}

                                                                    </ul>
                                                                </div>


                                                                <>
                                                                    <div className="tab-content" id="ex2-content">

                                                                        <div className={`  tab-pane fade show Ticketviewexpands   ${state.FormsIDList.ActiveTabs == 4
                                                                            ? "active "
                                                                            : ""
                                                                            }`}
                                                                            id="ex3-tabs-4"
                                                                            role="tabpanel"
                                                                            aria-labelledby="ex3-tab-4">




                                                                            <div className={`timeline timelineTicketListedRightside ${TickeREtrievdatas?.status == 3 ? "timelinewidthchanges ForStatusResolved" : ""}`}
                                                                                ref={timelineRef}
                                                                            >
                                                                                {state.TicketJournydatasofinternlandcient.ticketJourneyforinternal != undefined &&
                                                                                    state.TicketJournydatasofinternlandcient.ticketJourneyforinternal.length > 0 ?
                                                                                    <>
                                                                                        {state.TicketJournydatasofinternlandcient.ticketJourneyforinternal != undefined &&
                                                                                            state.TicketJournydatasofinternlandcient.ticketJourneyforinternal.length > 0 && state.TicketJournydatasofinternlandcient.ticketJourneyforinternal.map((item, index) => {
                                                                                                console.log(state.TicketJournydatasofinternlandcient.ticketJourneyforinternal.length, "Saidjopsadosdoisad oasid",


                                                                                                    state.TicketJournydatasofinternlandcient.ticketJourneyforinternal,
                                                                                                );
                                                                                                const firstName = item.qpms_user_id?.first_name ? item.qpms_user_id?.first_name.toUpperCase() : "";
                                                                                                const formattedName = firstName ? `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}` : "N/A";

                                                                                                const ticketImages = [ticketJourneyimg1, ticketJourneyimg2];

                                                                                                return (
                                                                                                    <>

                                                                                                        {item.name == item.description ?

                                                                                                            <div className='Movedrecords' key={index}>
                                                                                                                <div className='Arrowudsticketjouneryicons'>

                                                                                                                    {/* <img src={ticketactiveimgs} /> */}
                                                                                                                    <img src={index == 0 ? ticketJourneyimg1 : ticketJourneyimg2} />
                                                                                                                    {/* <img src={ticketImages[index % ticketImages.length]} alt="Journey Icon" /> */}
                                                                                                                </div>
                                                                                                                {index + 1 == state.TicketJournydatasofinternlandcient.ticketJourneyforinternal.length ? null : (
                                                                                                                    <>
                                                                                                                        <div className="Lineofnext"></div>
                                                                                                                    </>
                                                                                                                )}

                                                                                                                <div className='Movedrecordsdetails'>

                                                                                                                    {/* <p><span className="timestampcreated">{item.created_at ? formatedDateList(item.created_at) : ""}</span></p> */}
                                                                                                                    <>
                                                                                                                        {

                                                                                                                            <div className='TicketJouryneactives'>

                                                                                                                                <div className='innerdetailsofticketviewed'>

                                                                                                                                    <span className='TicketDetailsContent'>
                                                                                                                                        {item.name}
                                                                                                                                    </span>

                                                                                                                                    <span className="timestampcreatedticketjounery ">
                                                                                                                                        {item.created_at
                                                                                                                                            ? formatedDateListwithtime(item.created_at) : ""}

                                                                                                                                    </span>


                                                                                                                                </div>
                                                                                                                                <div className="TicketDetailsOfStatements">
                                                                                                                                    {/* {item.status === "0" ? `Created by ${item.qpms_user_id && item.qpms_user_id?.first_name ? item.qpms_user_id?.first_name : ""} (${item.qpms_user_id ? item.qpms_user_id?.user_role?.role : ""}) ` : */}
                                                                                                                                    {item.status === "0" ? `` :
                                                                                                                                        item.status === "1" ? `In Progress by ${item.qpms_user_id && item.qpms_user_id?.first_name ? item.qpms_user_id?.first_name : ""} (${item.qpms_user_id ? item.qpms_user_id?.user_role?.role : ""}) ` :
                                                                                                                                            item.status === "2" ? `Review by ${item.qpms_user_id && item.qpms_user_id?.first_name ? item.qpms_user_id?.first_name : ""} (${item.qpms_user_id ? item.qpms_user_id?.user_role?.role : ""}) ` :
                                                                                                                                                item.status === "3" ? `Resolved by ${item.qpms_user_id && item.qpms_user_id?.first_name ? item.qpms_user_id?.first_name : ""} (${item.qpms_user_id ? item.qpms_user_id?.user_role?.role : ""}) ` :
                                                                                                                                                    item.status === "4" ? `Reopened by ${item.qpms_user_id && item.qpms_user_id?.first_name ? item.qpms_user_id?.first_name : ""} (${item.qpms_user_id ? item.qpms_user_id?.user_role?.role : ""}) ` :
                                                                                                                                                        item.status === "5" ? `Rejected by ${item.qpms_user_id && item.qpms_user_id?.first_name ? item.qpms_user_id?.first_name : ""} (${item.qpms_user_id ? item.qpms_user_id?.user_role?.role : ""}) ` :
                                                                                                                                                            item.status === "6" ? `Assigned by ${item.qpms_user_id && item.qpms_user_id?.first_name ? item.qpms_user_id?.first_name : ""} (${item.qpms_user_id ? item.qpms_user_id?.user_role?.role : ""}) ` :
                                                                                                                                                                item.status === "7" && `Reassigned by ${item.qpms_user_id && item.qpms_user_id?.first_name ? item.qpms_user_id?.first_name : ""} (${item.qpms_user_id ? item.qpms_user_id?.user_role?.role : ""}) `}
                                                                                                                                </div>


                                                                                                                            </div>

                                                                                                                        }
                                                                                                                    </>




                                                                                                                </div>


                                                                                                            </div>
                                                                                                            :
                                                                                                            null
                                                                                                        }





                                                                                                    </>
                                                                                                )
                                                                                            })}

                                                                                    </>
                                                                                    : null}

                                                                            </div>

                                                                        </div>

                                                                        <div className={`  tab-pane fade show Ticketviewexpands   ${state.FormsIDList.ActiveTabs == 1
                                                                            ? "active "
                                                                            : ""
                                                                            }`}
                                                                            id="ex3-tabs-1"
                                                                            role="tabpanel"
                                                                            aria-labelledby="ex3-tab-1">




                                                                            <div className={`timeline timelineTicketListedRightside ${TickeREtrievdatas?.status == 3 ? "timelinewidthchanges ForStatusResolved" : ""}`}
                                                                                ref={timelineRef}
                                                                            >
                                                                                {state.retrievetheRemarks.Remarksdataslist != undefined &&
                                                                                    state.retrievetheRemarks.Remarksdataslist.length > 0 ?
                                                                                    <>
                                                                                        {state.retrievetheRemarks.Remarksdataslist != undefined &&
                                                                                            state.retrievetheRemarks.Remarksdataslist.length > 0 && state.retrievetheRemarks.Remarksdataslist.map((item, index) => {
                                                                                                console.log(index + 1, state.retrievetheRemarks.Remarksdataslist.length, "Saidjopsadosdoisad oasid");

                                                                                                const firstName = item.qpms_user_id?.first_name ? item.qpms_user_id?.first_name.toUpperCase() : "";
                                                                                                const formattedName = firstName ? `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}` : "N/A";

                                                                                                return (
                                                                                                    <>

                                                                                                        {item.name == item.description ?

                                                                                                            <div className='Movedrecords' key={index}>
                                                                                                                <div className='Arrowuds'><img src={doublArrow} /></div>
                                                                                                                {index + 1 == state.retrievetheRemarks.Remarksdataslist.length ? null : (
                                                                                                                    <>
                                                                                                                        <div className="Lineofnext"></div>
                                                                                                                        {/* <div className={`${state.retrievetheRemarks.Remarksdataslist.length == 2 ? "movedindex": "Lineofnext"}`}></div> */}
                                                                                                                    </>
                                                                                                                )}

                                                                                                                <div className='Movedrecordsdetails'>

                                                                                                                    <p><span className="timestampcreated">{item.created_at ? formatedDateList(item.created_at) : ""}</span></p>
                                                                                                                    <>
                                                                                                                        {
                                                                                                                            item.name === "Open to In Progress" || item.name === "In Progress to Review" ?

                                                                                                                                <>
                                                                                                                                    {item.name == "Open to In Progress" ?

                                                                                                                                        <>
                                                                                                                                            <p>{`Moved from ${`' Open ' to ' In Progress '`}`}</p>
                                                                                                                                        </> :

                                                                                                                                        <p>{`Moved from ${`' In Progress ' to ' Review '`}`}</p>
                                                                                                                                    }

                                                                                                                                </>

                                                                                                                                :
                                                                                                                                <p>{item.name} </p>

                                                                                                                        }
                                                                                                                    </>




                                                                                                                </div>


                                                                                                            </div>
                                                                                                            :

                                                                                                            <div className="timeline-item"
                                                                                                                ref={chatContainerRef}>
                                                                                                                <div className="timeline-icon TimeLinePersongIMGS">
                                                                                                                    {/* <img src={ticketactiveimgs} className='personImg' alt="" />
                                                                                                                     */}
                                                                                                                    <span>{item.qpms_user_id?.first_name ? formattedName : item.client_user_id?.first_name ? formattedName : "Not mention"}</span>
                                                                                                                    {/* <img src={profile2} alt="User" className='personImg' /> */}
                                                                                                                </div>

                                                                                                                {index + 1 == state.retrievetheRemarks.Remarksdataslist.length ? null : (
                                                                                                                    <div className='Lineofnext'></div>
                                                                                                                )}
                                                                                                                <div className={`timeline-content ${index + 1 != state.retrievetheRemarks.Remarksdataslist.length ? "forlefted" : ""}`} >
                                                                                                                    <div className='EscalationPersondetails'>


                                                                                                                        {item.name ? <p className="message">

                                                                                                                            <p className="user-name"

                                                                                                                            >
                                                                                                                                <span>
                                                                                                                                    {
                                                                                                                                        state.SideBarFiles.LoginIDs == item.qpms_user_id?.id ? "You" :
                                                                                                                                            item.qpms_user_id?.first_name ? capitalizeFirstLetter(item.qpms_user_id?.first_name) : "Not mention"

                                                                                                                                    }

                                                                                                                                </span>
                                                                                                                                <span className="timestamp">{item.created_at ? formatedDateList(item.created_at) : ""}</span>

                                                                                                                            </p>
                                                                                                                            {item.name ? capitalizeFirstLetter(item.name) : ""}






                                                                                                                            {Array.isArray(item.documents) && item.documents.length > 0 ? (
                                                                                                                                <div className="attachment">
                                                                                                                                    <img src={galleyimg} alt="Attachment" />
                                                                                                                                    <span>{item.documents.length} File Attached</span>

                                                                                                                                    {item.documents.map((document, index) => (
                                                                                                                                        <button
                                                                                                                                            key={index}
                                                                                                                                            className="download-btn"
                                                                                                                                            onClick={() => downloadAll(item.documents)}
                                                                                                                                        >
                                                                                                                                            <img src={downloadimg} alt="Download" />
                                                                                                                                        </button>
                                                                                                                                    ))}
                                                                                                                                </div>
                                                                                                                            ) : null}

                                                                                                                        </p>
                                                                                                                            : null}



                                                                                                                    </div>
                                                                                                                    <>



                                                                                                                        {/* {item.documents !== undefined && item.documents !== null && item.documents.length > 0 ? (
                                                                                                                            <div className="attachment">
                                                                                                                                <img src={galleyimg} alt="Attachment" />
                                                                                                                                <span>{item.documents.length} File Attached</span>

                                                                                                                                {item.documents.map((document, index) => (
                                                                                                                                    <button
                                                                                                                                        key={index}
                                                                                                                                        className="download-btn"
                                                                                                                                        // onClick={() => {
                                                                                                                                        //     const link = document.url || document; // Assuming the document has a URL
                                                                                                                                        //     window.open(link, "_blank"); // Open the document in a new tab
                                                                                                                                        // }}
                                                                                                                                        onClick={() => {
                                                                                                                                            downloadAll(item.documents)
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <img src={downloadimg} alt="Download" />
                                                                                                                                    </button>
                                                                                                                                ))}


                                                                                                                            </div>
                                                                                                                        ) : null} */}


                                                                                                                        {/* <a
                                                                                                                className="download-all-btn"
                                                                                                                onClick={() => {
                                                                                                                    downloadAll(item.documents)
                                                                                                                }}
                                                                                                            >
                                                                                                                Download All
                                                                                                            </a> */}
                                                                                                                    </>

                                                                                                                </div>
                                                                                                            </div>
                                                                                                        }




                                                                                                    </>
                                                                                                )
                                                                                            })}

                                                                                    </>
                                                                                    :
                                                                                    <><div className='CommunicationAlters'>
                                                                                        <p>
                                                                                            Communicate within the team, upload files, and add your notes easily in
                                                                                            <br />
                                                                                            one place to see the full history
                                                                                        </p>
                                                                                    </div></>}
                                                                            </div>
                                                                            {TickeREtrievdatas?.status == 3 ? null :

                                                                                <div className="message-input">
                                                                                    <form onSubmit={HandleSubmitticketactive}>

                                                                                        <label className='Droplabel'
                                                                                            htmlFor="fileUploadInput"
                                                                                            style={{ paddingTop: "6px", cursor: "pointer" }}
                                                                                            onClick={() => { setActiveonUploads(2) }}
                                                                                        >
                                                                                            <img src={Uploadimg} />
                                                                                        </label>
                                                                                        <input
                                                                                            id="fileUploadInput"
                                                                                            type="file"
                                                                                            style={{ display: "none" }}
                                                                                            onChange={handleFileChange}
                                                                                            multiple

                                                                                        />
                                                                                        <div style={{
                                                                                            display: "flex",
                                                                                            flexDirection: "row",
                                                                                            padding: "3px 3px"
                                                                                        }}>

                                                                                            <div className={`${ActiveofUploads == 2 && Remarskspopuo == false && PresentUrls.length > 0 ? "Innerholadimages" : ""}`}>
                                                                                                {Remarskspopuo == false &&
                                                                                                    ActiveofUploads == 2 &&

                                                                                                    PresentUrls.map((file, index) => {

                                                                                                        let displayImg;
                                                                                                        if (file.type === "image/png" || file.type === "image/jpeg") {
                                                                                                            displayImg = galleyimg; // Replace with your gallery image variable
                                                                                                        } else if (file.type === "application/pdf") {
                                                                                                            displayImg = PDFIMAGE; // Replace with your PDF icon variable
                                                                                                        } else if (file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                                                                                                            displayImg = excelimg; // Replace with your Excel icon variable
                                                                                                        } else {
                                                                                                            displayImg = gallimages; // Replace with a default image/icon if none match
                                                                                                        }
                                                                                                        return (
                                                                                                            <>

                                                                                                                <div key={index} style={{
                                                                                                                    position: "relative",
                                                                                                                    width: "38px",
                                                                                                                    height: "38px",
                                                                                                                    borderRadius: "8px",
                                                                                                                }}>
                                                                                                                    <img
                                                                                                                        src={displayImg}
                                                                                                                        alt={`Uploaded File ${index + 1}`}
                                                                                                                        style={{
                                                                                                                            width: "100%",
                                                                                                                            height: "100%",
                                                                                                                            objectFit: "cover",
                                                                                                                            borderRadius: "8px",
                                                                                                                            border: "1px solid #ddd",
                                                                                                                        }}
                                                                                                                    />
                                                                                                                    <button
                                                                                                                        type="button"
                                                                                                                        className=" btn-danger btn-sm CloseImagesSend"
                                                                                                                        style={{

                                                                                                                            marginRight: "1px",

                                                                                                                        }}

                                                                                                                        onClick={() => removeFile(index)}
                                                                                                                    >
                                                                                                                        &times;
                                                                                                                    </button>
                                                                                                                </div>
                                                                                                            </>
                                                                                                        )
                                                                                                    })}

                                                                                            </div>
                                                                                            <div className={`Containsthebothfields ${ActiveofUploads != 1 && Remarskspopuo == false && PresentUrls.length > 0 ? "increasethetops" : ""}`}>
                                                                                                {suggestions.length > 0 && (
                                                                                                    <ul
                                                                                                        style={{
                                                                                                            position: "absolute",
                                                                                                            top: "-147px",
                                                                                                            left: "0",
                                                                                                            width: "100%",
                                                                                                            listStyleType: "none",
                                                                                                            margin: 0,
                                                                                                            padding: "5px 0",
                                                                                                            backgroundColor: "#fff",
                                                                                                            border: "1px solid #ccc",
                                                                                                            borderRadius: "4px",
                                                                                                            zIndex: 9999999988,
                                                                                                            height: "140px",
                                                                                                            overflow: "scroll"
                                                                                                        }}
                                                                                                    >

                                                                                                        {remarks?.name != "" && suggestions.map((user, index) => {
                                                                                                            const searchText = remarks.name.split("@").pop().toLowerCase();
                                                                                                            const isActive = index === activeSuggestionIndex;
                                                                                                            return (
                                                                                                                <li
                                                                                                                    key={user.id}
                                                                                                                    onClick={() => handleSelectSuggestion(user)}
                                                                                                                    style={{
                                                                                                                        padding: "8px",
                                                                                                                        cursor: "pointer",
                                                                                                                        backgroundColor: isActive ? "#e6e6e6" : "#f9f9f9",
                                                                                                                        borderBottom: "1px solid #eee",

                                                                                                                    }}
                                                                                                                    onMouseOver={() => setActiveSuggestionIndex(index)}
                                                                                                                >
                                                                                                                    {highlightMatch(user?.name, searchText)}
                                                                                                                </li>
                                                                                                            );
                                                                                                        })}

                                                                                                    </ul>
                                                                                                )}
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    placeholder="Type your message here..."
                                                                                                    onChange={(e) => {
                                                                                                        HandleChangescommentsticketactive(e)

                                                                                                    }}
                                                                                                    onKeyDown={handleKeyDown}
                                                                                                    value={remarks.name}
                                                                                                />




                                                                                                <button className="send-btn"
                                                                                                    type='Submit'
                                                                                                // onClick={() => {
                                                                                                //     HandleRemarksWithudsusers() // for the comments
                                                                                                // }}
                                                                                                // onClick={() => {
                                                                                                //     if (activeSuggestionIndex === -1) {
                                                                                                //         HandleRemarksWithudsusers(); 
                                                                                                //     }
                                                                                                // }}

                                                                                                >
                                                                                                    <img src={sendimg} />

                                                                                                </button>
                                                                                            </div>

                                                                                        </div>

                                                                                    </form>


                                                                                </div>
                                                                            }
                                                                        </div>


                                                                        <div className={`  tab-pane fade show  Ticketviewexpands ${state.FormsIDList.ActiveTabs == 3
                                                                            ? "active "
                                                                            : ""
                                                                            }`}
                                                                            id="ex3-tabs-3"
                                                                            role="tabpanel"
                                                                            aria-labelledby="ex3-tab-3">




                                                                            <div className={`timeline timelineTicketListedRightside ${TickeREtrievdatas?.status == 3 ? "timelinewidthchanges ForStatusResolved" : ""}`}
                                                                                ref={timelineRefremarks}
                                                                            >

                                                                                <>
                                                                                    {state.commentsDatas.CommentsDatas != undefined &&
                                                                                        state.commentsDatas.CommentsDatas.length > 0 && state.commentsDatas.CommentsDatas.map((item, index) => {

                                                                                            return (
                                                                                                <>

                                                                                                    <div className="timeline-item"
                                                                                                        // ref={Remarkesref}
                                                                                                        ref={Remarkesref}
                                                                                                    >
                                                                                                        <div className="timeline-icon TimeLinePersongIMGS">
                                                                                                            <img src={ticketactiveimgs} className='personImg' alt="" />
                                                                                                        </div>

                                                                                                        {state.commentsDatas?.CommentsDatas?.length &&
                                                                                                            index + 1 !== state.commentsDatas.CommentsDatas.length && (
                                                                                                                <div className='Lineofnext'></div>
                                                                                                            )
                                                                                                        }
                                                                                                        <div className="timeline-content">
                                                                                                            <div className='EscalationPersondetails'>

                                                                                                                <p className="user-name">
                                                                                                                    {state.SideBarFiles.LoginIDs == item.qpms_user_id?.id ? "You" :
                                                                                                                        item.qpms_user_id?.first_name ? capitalizeFirstLetter(item.qpms_user_id?.first_name) :

                                                                                                                            item.client_user_id?.first_name ?
                                                                                                                                capitalizeFirstLetter(item.client_user_id?.first_name) :
                                                                                                                                "Not mention"}



                                                                                                                    {(state.SideBarFiles.LoginIDs !== item.qpms_user_id?.id && item.client_user_id?.first_name) ||
                                                                                                                        item.qpms_user_id?.first_name ? (
                                                                                                                        <>
                                                                                                                            {state.SideBarFiles.LoginIDs !== item.qpms_user_id?.id ? (
                                                                                                                                <button className='MentiontheUSer'>
                                                                                                                                    {state.SideBarFiles.LoginIDs === item.qpms_user_id?.id
                                                                                                                                        ? ""
                                                                                                                                        : item.qpms_user_id?.first_name
                                                                                                                                            ? "QPMS"
                                                                                                                                            : item.client_user_id?.first_name
                                                                                                                                                ? "CLIENT"
                                                                                                                                                : ""}
                                                                                                                                </button>
                                                                                                                            ) : null}
                                                                                                                        </>
                                                                                                                    ) : null}

                                                                                                                </p>
                                                                                                                <span className="timestamp">{item.created_at ? formatedDateList(item.created_at) : ""}</span>
                                                                                                            </div>
                                                                                                            <>

                                                                                                                {item.name ? <p className="message">
                                                                                                                    {item.name ? capitalizeFirstLetter(item.name) : ""}
                                                                                                                </p>
                                                                                                                    : null}

                                                                                                                {/* {item.documents !== undefined && item.documents !== null && item.documents.length > 0 ? (
                                                                                                                    <div className="attachment">
                                                                                                                        <img src={galleyimg} alt="Attachment" />
                                                                                                                        <span>{item.documents.length} File Attached</span>

                                                                                                                        {item.documents.map((document, index) => (
                                                                                                                            <button
                                                                                                                                key={index}
                                                                                                                                className="download-btn"
                                                                                                                                onClick={() => downloadAll(item.documents)}

                                                                                                                            >
                                                                                                                                <img src={downloadimg} alt="Download" />
                                                                                                                            </button>
                                                                                                                        ))}
                                                                                                                    </div>
                                                                                                                ) : null} */}

                                                                                                                {Array.isArray(item.documents) && item.documents.length > 0 ? (
                                                                                                                    <div className="attachment">
                                                                                                                        <img src={galleyimg} alt="Attachment" />
                                                                                                                        <span>{item.documents.length} File Attached</span>

                                                                                                                        {item.documents.map((document, index) => (
                                                                                                                            <button
                                                                                                                                key={index}
                                                                                                                                className="download-btn"
                                                                                                                                onClick={() => downloadAll(item.documents)}
                                                                                                                            >
                                                                                                                                <img src={downloadimg} alt="Download" />
                                                                                                                            </button>
                                                                                                                        ))}
                                                                                                                    </div>
                                                                                                                ) : null}


                                                                                                            </>

                                                                                                        </div>
                                                                                                    </div>





                                                                                                </>
                                                                                            )
                                                                                        })}

                                                                                </>

                                                                            </div>

                                                                            {TickeREtrievdatas?.status == 3 ? null :
                                                                                <div className="message-input">
                                                                                    <form onSubmit={HandleSubmit}>


                                                                                        <label className='Droplabel'
                                                                                            htmlFor="fileUploadInput"
                                                                                            style={{ paddingTop: "6px", cursor: "pointer" }}
                                                                                        >
                                                                                            <img src={Uploadimg} />
                                                                                        </label>
                                                                                        <input
                                                                                            id="fileUploadInput"
                                                                                            type="file"
                                                                                            style={{ display: "none" }}
                                                                                            onChange={handleFileChange}
                                                                                            multiple
                                                                                        />
                                                                                        <div style={{
                                                                                            display: "flex",
                                                                                            flexDirection: "row",
                                                                                            padding: "3px 3px"
                                                                                        }}>

                                                                                            <div className={`${PresentUrls.length > 0 ? "Innerholadimages" : ""}`}>
                                                                                                {Remarskspopuo == false &&
                                                                                                    PresentUrls.map((file, index) => {
                                                                                                        // console.log(file, "asdpuasod file");

                                                                                                        let displayImg;
                                                                                                        if (file.type === "image/png" || file.type === "image/jpeg") {
                                                                                                            displayImg = galleyimg; // Replace with your gallery image variable
                                                                                                        } else if (file.type === "application/pdf") {
                                                                                                            displayImg = PDFIMAGE; // Replace with your PDF icon variable
                                                                                                        } else if (file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                                                                                                            displayImg = excelimg; // Replace with your Excel icon variable
                                                                                                        } else {
                                                                                                            displayImg = gallimages; // Replace with a default image/icon if none match
                                                                                                        }
                                                                                                        return (
                                                                                                            <>

                                                                                                                <div key={index} style={{
                                                                                                                    position: "relative",
                                                                                                                    width: "38px",
                                                                                                                    height: "38px",
                                                                                                                    borderRadius: "8px",
                                                                                                                }}>
                                                                                                                    <img
                                                                                                                        src={displayImg}
                                                                                                                        alt={`Uploaded File ${index + 1}`}
                                                                                                                        style={{
                                                                                                                            width: "100%",
                                                                                                                            height: "100%",
                                                                                                                            objectFit: "cover",
                                                                                                                            borderRadius: "8px",
                                                                                                                            border: "1px solid #ddd",
                                                                                                                        }}
                                                                                                                    />
                                                                                                                    <button
                                                                                                                        type="button"
                                                                                                                        className=" btn-danger btn-sm CloseImagesSend"
                                                                                                                        style={{

                                                                                                                            marginRight: "1px",

                                                                                                                        }}

                                                                                                                        onClick={() => removeFile(index)}
                                                                                                                    >
                                                                                                                        &times;
                                                                                                                    </button>
                                                                                                                </div>
                                                                                                            </>
                                                                                                        )
                                                                                                    })}

                                                                                            </div>

                                                                                            {/* <div className='Containsthebothfields'> */}
                                                                                            <div className={`Containsthebothfields ${Remarskspopuo == false && PresentUrls.length > 0 ? "increasethetops" : ""}`}>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    placeholder="Type your message here..."
                                                                                                    onChange={(e) => {
                                                                                                        if (Remarskspopuo == false) {
                                                                                                            HandleChangescomments(e)

                                                                                                        }
                                                                                                    }}
                                                                                                    value={Remarskspopuo == false ? comment.name : ""}
                                                                                                    name="name"
                                                                                                />


                                                                                                <button className="send-btn"
                                                                                                    type='Submit'

                                                                                                    onClick={() => {
                                                                                                        HandleRemarsks("3") /// This is for the remarks
                                                                                                    }}
                                                                                                >
                                                                                                    <img src={sendimg} />

                                                                                                </button>
                                                                                            </div>

                                                                                        </div>




                                                                                    </form>

                                                                                </div>
                                                                            }

                                                                        </div>


                                                                        <div
                                                                            className={`  tab-pane fade show   ${state.FormsIDList.ActiveTabs == 2
                                                                                ? "active  "
                                                                                : ""
                                                                                }`}
                                                                            id="ex3-tabs-2"
                                                                            role="tabpanel"
                                                                            aria-labelledby="ex3-tab-2"
                                                                        >
                                                                            <div className={`timeline  timelineTicketListedRightside ${TickeREtrievdatas?.status == 3 ? "timelinewidthchanges ForStatusResolved" : ""}`} style={{ marginTop: "20px" }} ref={Remarkesref}>
                                                                                {state.ticketFeedbacklistedslice.feedbackrecords != undefined && state.ticketFeedbacklistedslice.feedbackrecords.length > 0 && state.ticketFeedbacklistedslice.feedbackrecords.map((item) => {

                                                                                    return (
                                                                                        <>
                                                                                            <div className="timeline-item">
                                                                                                <div className="timeline-icon TimeLinePersongIMGS">
                                                                                                    <img src={ticketactiveimgs} alt="User" className='personImg' />
                                                                                                </div>
                                                                                                <div className="timeline-content TicketClientFeedback">
                                                                                                    <div className='EscalationPersondetails'>
                                                                                                        <span className="user-name-client">{item.client_user_id?.first_name ? capitalizeEachWord(item.client_user_id?.first_name.toLowerCase()) : ""}</span>
                                                                                                        {/* <p className="user-name">{item.client_user_id?.first_name ? capitalizeEachWord(item.client_user_id?.first_name.toLowerCase()) : ""}</p> */}
                                                                                                        <div className='satificedandlabels'>
                                                                                                            {/* <span>
                                                                                                            
                                                                                                            {item.satisfaction ?
                                                                                                            // capitalizeEachWord(item.satisfaction.toLowerCase()) 
                                                                                                            : ""}</span> */}








                                                                                                            <span className="timestamp">
                                                                                                                {item.created_at ? formatedDateList(item.created_at) : ""}

                                                                                                                {/* {item.created_at ? formatDateTime(item.created_at) : ""} */}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <p className="messageclients">
                                                                                                        {item.feedbacks ? capitalizeEachWord(item.feedbacks) : ""}
                                                                                                    </p>

                                                                                                    <div className='Messageimgs'>

                                                                                                        {feedbackOptions.map((option) => (
                                                                                                            <div
                                                                                                                key={option.id}
                                                                                                                aria-selected={item.satisfaction === option.id}

                                                                                                                className={`feedback-option ${item.satisfaction === option.id ? "active" : ""}`}

                                                                                                            >
                                                                                                                <img
                                                                                                                    // src={option.imgSrc}
                                                                                                                    src={item.satisfaction == option.id ? option.backimg : option.imgSrc}
                                                                                                                    alt={option.label} />
                                                                                                                <span className={`${item.satisfaction === option.id ? "activelabe" : ""}`}>{option.label}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>

                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    )
                                                                                })}

                                                                            </div>

                                                                        </div>



                                                                    </div>


                                                                </>

                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>

                                            </div>

                                            {TickeREtrievdatas?.is_user_editable == true &&
                                                TickeREtrievdatas?.status != 2 &&
                                                TickeREtrievdatas?.status != 3 ?

                                                <div className='FormSubmitions'>
                                                    <>
                                                        {StoretheEscalate != "view" || TickeREtrievdatas?.status == 4  ?
                                                            <div className='StarttheProgress'>
                                                                <span>
                                                                    {TickeREtrievdatas?.status == 0 ? "Click here to start progress" : "Click here to Submit for Review"}
                                                                </span>
                                                                <button
                                                                    onClick={() => {
                                                                        // setTicketConfirmPopup(true)
                                                                        if (TickeREtrievdatas?.status != 0) {
                                                                            setremarkspopup(true)
                                                                        }
                                                                        else {
                                                                            // setremarkspopup(true)
                                                                            setTicketConfirmPopup(true);
                                                                        }

                                                                    }}

                                                                >
                                                                    {TickeREtrievdatas?.status == 0 ? "Start" : "SUBMIT"}
                                                                </button>

                                                            </div>
                                                            : null}
                                                    </>
                                                </div>
                                                : null}



                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {Remarskspopuo && (
                <>

                    <div className="RoleCreatePopup">
                        <div className="BeforePopUp">
                            <div className="RolePopups" style={{ width: "30%" }}>
                                <div className="asds">
                                    <div class="ModalHeader" style={{ background: "transparent" }}>
                                        {TickeREtrievdatas?.status == 0 ? "Sending it for in progress now" : "Add remarks "}
                                        <div className="CloseIcon" onClick={(e) => {
                                            setcomment(initialState2);
                                            setUploadedFiles([]);
                                            setcroppedFilestatet([]);
                                            setPresentUrls([]);
                                            seturlandfile([])
                                            setremarkspopup(false);
                                        }}>
                                            <CloseOutlinedIcon />
                                        </div>
                                    </div>
                                    <form class="row g-3 form-fields-wrapper" >
                                        {/* <div className="col-12 field-div">
                                            <label className="form-label" style={{ fontSize: "15px" }}>
                                                Status                                        <span style={{ color: "red" }}>*</span>

                                            </label>
                                            <Select options={options} onChange={(e) => {
                                                setcomment({
                                                    ...comment,
                                                    status: e.value
                                                })
                                            }} />

                                        </div> */}
                                        <div className="col-12 mt-2 field-div">
                                            <label className="form-label" style={{ fontSize: "15px" }}>
                                                Remarks
                                                <span style={{ color: "red" }}>*</span>

                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                value={comment.name}
                                                autoComplete="off"
                                                onChange={(e) => {
                                                    HandleChangescomments(e);
                                                }}
                                                required
                                                name="name"
                                                style={{
                                                    padding: "10px",
                                                }}
                                            ></input>

                                        </div>

                                        {TickeREtrievdatas.over_due == true ?
                                            <div className="col-12 mt-2 field-div">
                                                <label className="form-label" style={{ fontSize: "15px" }}>
                                                    Reason
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    value={ticketactivenames}
                                                    autoComplete="off"
                                                    onChange={(e) => {
                                                        setticketactivenames(e.target.value);
                                                    }}
                                                    required
                                                    name="name"
                                                    style={{
                                                        padding: "10px",
                                                    }}
                                                ></input>

                                            </div>
                                            : null}

                                        <div className="col-12 mt-3 DocumentsUpload">
                                            <label className="form-label" >
                                                Documents Upload
                                            </label>
                                            <div
                                                className="form-control InnerControls"

                                                onDrop={handleDrop}
                                                onDragOver={handleDragOver}

                                                onDragEnter={handleDragEnter}
                                                onDragLeave={handleDragLeave}
                                                style={{
                                                    borderRadius: "10px",
                                                    textAlign: "center",
                                                    backgroundColor: isDragging ? "hsla(203, 49%, 81%, 0.25)" : "transparent", // Change background color
                                                    transition: "background-color 0.3s ease", // Smooth transition

                                                }}
                                            >
                                                <div className="d-flex flex-wrap align-items-center gap-3 ImageContainersGaps">
                                                    {
                                                        // uploadedFiles
                                                        PresentUrls.map((file, index) => {

                                                            let displayImg;
                                                            if (file.type === "image/png" || file.type === "image/jpeg") {
                                                                displayImg = galleyimg; // Replace with your gallery image variable
                                                            } else if (file.type === "application/pdf") {
                                                                displayImg = PDFIMAGE; // Replace with your PDF icon variable
                                                            } else if (file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                                                                displayImg = excelimg; // Replace with your Excel icon variable
                                                            } else {
                                                                displayImg = gallimages; // Replace with a default image/icon if none match
                                                            }
                                                            return (
                                                                <>

                                                                    <div key={index} style={{
                                                                        position: "relative",
                                                                        width: "38px",
                                                                        height: "38px",
                                                                        borderRadius: "8px",
                                                                    }}>
                                                                        <img
                                                                            src={displayImg}
                                                                            alt={`Uploaded File ${index + 1}`}
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "100%",
                                                                                objectFit: "cover",
                                                                                borderRadius: "8px",
                                                                                border: "1px solid #ddd",
                                                                            }}
                                                                        />

                                                                        <span
                                                                            style={{
                                                                                fontSize: "12px",
                                                                                textTransform: "capitalize",
                                                                            }}
                                                                        >
                                                                            {file?.putfiles?.name?.length > 5
                                                                                ? `${file?.putfiles.name.slice(
                                                                                    0,
                                                                                    5
                                                                                )}...`
                                                                                : file?.putfiles?.name}
                                                                        </span>

                                                                        <button
                                                                            type="button"
                                                                            className=" btn-danger btn-sm DeleteImages"

                                                                            onClick={() => removeFile(index)}
                                                                        >
                                                                            &times;
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}


                                                </div>



                                                <p className="mt-3 " >
                                                    Drag your files here to upload or{" "}
                                                    <label className='Droplabel dragdropedis'
                                                        htmlFor="fileUploadInput"

                                                    >
                                                        Browse file
                                                    </label>
                                                    <input
                                                        id="fileUploadInput"
                                                        type="file"
                                                        style={{ display: "none" }} // Hidden input
                                                        onChange={handleFileChange} // Handles file selection
                                                        multiple // Allows multiple file selection
                                                    />
                                                </p>

                                            </div>
                                        </div>

                                    </form>
                                    <div
                                        className="RoleButton"
                                        style={{
                                            display: "flex",
                                            gap: "15px",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                        }}
                                    >


                                        <button
                                            class="btn  SaveBtn"
                                            type="submit"
                                            // onClick={() => { HandleRemarsks(1) }}
                                            onClick={() => {
                                                // if (TickeREtrievdatas?.status != 0) {
                                                handletheticketupdated(TickeREtrievdatas?.status == 0 ? "1" : "2");
                                                // }
                                                // else {
                                                // setTicketConfirmPopup(true)
                                                // }


                                            }}


                                        >
                                            Submit
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </>


            )}


            {TickeREtrievdatas?.status == 3 && Commentpopup ? (
                <>

                    <div className="RoleCreatePopup">
                        <div className="BeforePopUp">
                            <div className="RolePopups" style={{ width: "30%" }}>
                                <div className="asds">
                                    <div class="ModalHeader">
                                        Add a Comment
                                        <div className="CloseIcon" onClick={(e) => setcommetpoup(false)}>
                                            <CloseOutlinedIcon />
                                        </div>
                                    </div>
                                    <form class="row g-3 form-fields-wrapper" >

                                        <div className="col-12 field-div">
                                            <label className="form-label" style={{ fontSize: "15px" }}>
                                                Please provide a reason for Reopening
                                                this ticket
                                            </label>
                                            <textarea
                                                type="text"
                                                class="form-control"
                                                value={comment.name}
                                                autoComplete="off"
                                                onChange={(e) => {
                                                    HandleChangescomments(e);
                                                }}
                                                required
                                                name="name"
                                                style={{
                                                    padding: "10px",
                                                }}
                                            ></textarea>

                                        </div>

                                    </form>
                                    <div
                                        className="RoleButton"
                                        style={{
                                            display: "flex",
                                            gap: "15px",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                        }}
                                    >

                                        <button
                                            class="btn  SaveBtn"
                                            type="submit"
                                            onClick={HandleTheComments}

                                        >
                                            Close Ticket
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </>


            ) : <></>}

            {TicketConfirmPopup && (
                <>

                    <div className="RoleCreatePopup">
                        <div className="BeforePopUp">
                            <div className="RolePopups" style={{ width: "30%" }}>
                                <div className="asds">
                                    <div class="ModalHeader" style={{ background: "transparent", display: "flex", justifyContent: "flex-end", border: "none" }}>
                                        <div className="CloseIcon" onClick={(e) => {
                                            setTicketConfirmPopup(false);
                                        }}>
                                            <CloseOutlinedIcon />
                                        </div>
                                    </div>
                                    <div class="row g-3 ConfirmProceeds" onSubmit={(e) => e.preventDefault()}>
                                        <h3>Confirm to proceed</h3>
                                        <div className='InnerConfirmationPopups'>
                                            <p>{TickeREtrievdatas?.status == 0 ? "Would you like to move this ticket to 'In Progress' ?" : "Do you want to Review the ticket"}</p>
                                        </div>
                                    </div>

                                    <div
                                        className="RoleButton confimpopupdesigns"
                                        style={{
                                            display: "flex",
                                            gap: "15px",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <button
                                            class="btn  SaveBtnNo"
                                            type="submit"
                                            onClick={() => {
                                                setTicketConfirmPopup(false);

                                            }
                                            }

                                        >
                                            {"No"}
                                        </button>

                                        <button
                                            class="btn  SaveBtn"
                                            type="submit"
                                            onClick={() => {
                                                // if (TickeREtrievdatas?.status != 0) {
                                                handletheticketupdated(TickeREtrievdatas?.status == 0 ? "1" : "2");
                                                // }
                                                // else {
                                                //     setTicketConfirmPopup(true)
                                                // }



                                            }
                                            }

                                        >
                                            {TickeREtrievdatas?.status == 0 ? "Yes" : "REVIEW"}
                                        </button>

                                    </div>



                                </div>
                            </div>
                        </div>
                    </div>

                </>



            )}


            <>
                <div className='Attachmentviedetails'>
                    {isModalOpen && (
                        <div className="modal">
                            <div className="modal-content">
                                <div className="ModalHeader">
                                    <span>Attachment</span>
                                    <div
                                        className="CloseIcon"
                                        onClick={() => setModalOpen(false)}
                                    >
                                        <CloseOutlinedIcon />
                                    </div>
                                </div>

                                <ul>
                                    {TickeREtrievdatas?.documents.
                                        // slice(2) 
                                        map((doc, index) => {
                                            const fileExtension = doc.split('.').pop().toLowerCase();

                                            // Determine the display image based on the file extension
                                            let displayImg;
                                            if (fileExtension === "png" || fileExtension === "jpeg" || fileExtension === "jpg") {
                                                displayImg = galleyimg; // Replace with your gallery image variable
                                            } else if (fileExtension === "pdf") {
                                                displayImg = PDFIMAGE; // Replace with your PDF icon variable
                                            } else if (fileExtension === "xls" || fileExtension === "xlsx") {
                                                displayImg = excelimg; // Replace with your Excel icon variable
                                            } else {
                                                displayImg = gallimages; // Default image/icon
                                            }


                                            return (
                                                <li key={index} style={{ marginBottom: "16px" }}>
                                                    <div div className='card'

                                                        onClick={() => window.open(doc, "_blank")}
                                                    >
                                                        <div className='Folderimgs'>
                                                            <img src={displayImg} />
                                                        </div>



                                                        <div className='card-body'>
                                                            <div>

                                                            {doc.split('/').pop().length > 9
                                                                                    ? `${doc.split('/').pop().slice(
                                                                                        0,
                                                                                        9
                                                                                    )}...`
                                                                                    : doc.split('/').pop()}

                                                                {/* {doc ? doc.split('/').pop() : ""} */}
                                                                {/* Document.{doc.split(".").pop().toUpperCase()} */}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </li>
                                            )
                                        }

                                        )}


                                </ul>

                            </div>
                        </div>

                    )}
                </div>
            </>

            {/* <Tooltip id="my-tooltip" place="top" effect="solid" /> */}

        </>



    )
}

export default TicketIViews